(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3430],{

/***/ 804:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[id]",
      function () {
        return __webpack_require__(76965);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ew": function() { return /* binding */ EllipsisTextStyle; },
/* harmony export */   "Sk": function() { return /* binding */ LineClampTextStyled; },
/* harmony export */   "kM": function() { return /* binding */ SelectableText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  ",
        ";\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  -webkit-user-select: text;\n  user-select: text;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var EllipsisTextStyle = "\n  overflow: hidden;\n  white-space: normal;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-break: keep-all;\n  ";
var LineClampTextStyled = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9616346d-0"
})(_templateObject(), function(param) {
    var lineNumber = param.lineNumber;
    return "-webkit-line-clamp: ".concat(lineNumber);
}, function(param) {
    var isSelectable = param.isSelectable;
    return isSelectable && "\n    -webkit-user-select: text;\n    user-select: text;\n  ";
});
var SelectableText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9616346d-1"
})(_templateObject1());


/***/ }),

/***/ 40906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_PaginationComponent; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67557);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(98240);
// EXTERNAL MODULE: ../../node_modules/lucide-react/dist/esm/icons/ellipsis.js
var ellipsis = __webpack_require__(60301);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ../../node_modules/class-variance-authority/dist/index.mjs
var dist = __webpack_require__(10929);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/dnDesignSystem/components/ui/pagination.tsx











var paginationVariants = (0,dist/* cva */.j)("typography-ui-17sb flex items-center justify-center", {
    variants: {
        variant: {
            disabled: "rounded-[50%] bg-white",
            default: "rounded-[50%] bg-white text-gray-500 hover:bg-gray-50",
            active: "rounded-[50%] bg-primary-600 text-white"
        },
        size: {
            default: "h-[32px] min-w-[32px] px-[2px]",
            icon: "h-[28px] min-w-[28px] px-[2px]"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
var Pagination = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("nav", (0,_object_spread/* default */.Z)({
        role: "navigation",
        "aria-label": "pagination",
        className: (0,style.cn)("mx-auto mt-[20px] flex w-full justify-center", className)
    }, props));
};
Pagination.displayName = "Pagination";
var PaginationContent = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("ul", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,style.cn)("flex flex-row items-center gap-[12px]", className)
    }, props));
});
PaginationContent.displayName = "PaginationContent";
var PaginationItem = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("li", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,style.cn)("", className)
    }, props));
});
PaginationItem.displayName = "PaginationItem";
var PaginationLink = function(_param) {
    var className = _param.className, isActive = _param.isActive, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _size = _param.size, size = _size === void 0 ? "default" : _size, href = _param.href, _scroll = _param.scroll, scroll = _scroll === void 0 ? true : _scroll, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "isActive",
        "variant",
        "size",
        "href",
        "scroll"
    ]);
    var disabled = variant === "disabled";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-current": isActive ? "page" : undefined,
        href: href,
        scroll: scroll
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "aria-disabled": disabled,
            tabIndex: disabled ? -1 : undefined,
            className: (0,style.cn)(paginationVariants({
                variant: variant,
                size: size
            }), className, disabled ? "pointer-events-none" : ""),
            children: props.children
        })
    }));
};
PaginationLink.displayName = "PaginationLink";
var PaginationPrevious = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to previous page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_arrow_left",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationPrevious.displayName = "PaginationPrevious";
var PaginationDoublePrevious = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to double previous page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_double_arrow_left",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationDoublePrevious.displayName = "PaginationDoublePrevious";
var PaginationNext = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to next page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_arrow_right",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationNext.displayName = "PaginationNext";
var PaginationDoubleNext = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to double next page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_double_arrow_right",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationDoubleNext.displayName = "PaginationDoubleNext";
var PaginationEllipsis = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsxs)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-hidden": true,
        className: (0,style.cn)("flex h-9 w-9 items-center justify-center", className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ellipsis/* default */.Z, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "More pages"
            })
        ]
    }));
};
PaginationEllipsis.displayName = "PaginationEllipsis";


;// CONCATENATED MODULE: ./src/hooks/common/usePagination.ts

var PaginationType;
(function(PaginationType) {
    PaginationType["DOUBLE_PREVIOUS"] = "DOUBLE_PREVIOUS";
    PaginationType["PREVIOUS"] = "PREVIOUS";
    PaginationType["NEXT"] = "NEXT";
    PaginationType["DOUBLE_NEXT"] = "DOUBLE_NEXT";
    PaginationType["LINK"] = "LINK";
})(PaginationType || (PaginationType = {}));
var getPageInfos = function(page, totalPage, perPage) {
    var pageInfo = [];
    var halfPerPage = Math.floor(perPage / 2);
    var startPage = page - halfPerPage;
    var endPage = page + halfPerPage;
    if (startPage < 1) {
        startPage = 1;
        endPage = Math.min(perPage, totalPage);
    } else if (endPage > totalPage) {
        endPage = totalPage;
        startPage = Math.max(1, totalPage - perPage + 1);
    }
    var doublePreviousPage = Math.max(1, page - perPage);
    pageInfo.push({
        type: PaginationType.DOUBLE_PREVIOUS,
        page: doublePreviousPage,
        isActive: page > 1
    });
    var previousPage = Math.max(1, page - 1);
    pageInfo.push({
        type: PaginationType.PREVIOUS,
        page: previousPage,
        isActive: page > 1
    });
    for(var i = startPage; i <= endPage; i++){
        pageInfo.push({
            type: PaginationType.LINK,
            page: i,
            isActive: i === page
        });
    }
    var nextPage = Math.min(totalPage, page + 1);
    pageInfo.push({
        type: PaginationType.NEXT,
        page: nextPage,
        isActive: page < totalPage
    });
    var doubleNextPage = Math.min(totalPage, page + perPage);
    pageInfo.push({
        type: PaginationType.DOUBLE_NEXT,
        page: doubleNextPage,
        isActive: page < totalPage
    });
    return pageInfo;
};
var usePagination = function(page, totalPage) {
    var perPage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    var ref = (0,react.useState)(function() {
        return getPageInfos(page, totalPage, perPage);
    }), pageInfos = ref[0], setPageInfos = ref[1];
    (0,react.useEffect)(function() {
        setPageInfos(getPageInfos(page, totalPage, perPage));
    }, [
        page,
        totalPage,
        perPage
    ]);
    return pageInfos;
};
/* harmony default export */ var common_usePagination = (usePagination);

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/hooks/useScrollRestoration.ts


var useScrollRestoration = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        ref: undefined,
        enabled: true
    }, ref1 = ref.ref, _enabled = ref.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var router = (0,next_router.useRouter)();
    var isPopStateRef = (0,react.useRef)(false);
    var pendingScrollRef = (0,react.useRef)(null);
    var scrollKey = function(path) {
        return "scrollPos_".concat(path);
    };
    var saveScrollPos = function(path) {
        var scrollPos = (ref1 === null || ref1 === void 0 ? void 0 : ref1.current) ? {
            x: ref1.current.scrollLeft,
            y: ref1.current.scrollTop
        } : {
            x: window.scrollX,
            y: window.scrollY
        };
        sessionStorage.setItem(path, JSON.stringify(scrollPos));
    };
    var getSavedScrollPos = function(path) {
        var savedPos = sessionStorage.getItem(path);
        if (!savedPos) return null;
        return JSON.parse(savedPos);
    };
    var applyScrollPosition = function(x, y) {
        var targetElement = (ref1 === null || ref1 === void 0 ? void 0 : ref1.current) || window;
        requestAnimationFrame(function() {
            targetElement.scrollTo(x, y);
        });
    };
    (0,react.useLayoutEffect)(function() {
        if (enabled && pendingScrollRef.current) {
            var _current = pendingScrollRef.current, x = _current.x, y = _current.y;
            applyScrollPosition(x, y);
            pendingScrollRef.current = null;
        }
    });
    (0,react.useLayoutEffect)(function() {
        if (!enabled) return;
        if (!("scrollRestoration" in window.history)) return;
        window.history.scrollRestoration = "manual";
        var currentPath = scrollKey(router.asPath);
        var onRouteChangeStart = function() {
            if (!isPopStateRef.current) {
                saveScrollPos(currentPath);
            }
        };
        var onRouteChangeComplete = function() {
            var newPath = scrollKey(router.asPath);
            if (isPopStateRef.current) {
                var savedPos = getSavedScrollPos(newPath);
                if (savedPos) {
                    pendingScrollRef.current = savedPos;
                }
                isPopStateRef.current = false;
            } else {
                pendingScrollRef.current = {
                    x: 0,
                    y: 0
                };
            }
        };
        router.beforePopState(function() {
            isPopStateRef.current = true;
            return true;
        });
        router.events.on("routeChangeStart", onRouteChangeStart);
        router.events.on("routeChangeComplete", onRouteChangeComplete);
        return function() {
            router.events.off("routeChangeStart", onRouteChangeStart);
            router.events.off("routeChangeComplete", onRouteChangeComplete);
        };
    }, [
        ref1,
        router.asPath,
        enabled
    ]);
};

// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/components/common/PaginationComponent.tsx








var PaginationComponent = function(props) {
    var queries = props.queries, baseUrl = props.baseUrl, _pageKeyName = props.pageKeyName, pageKeyName = _pageKeyName === void 0 ? "page" : _pageKeyName, _scroll = props.scroll, scroll = _scroll === void 0 ? true : _scroll, _scrollRestoration = props.scrollRestoration, scrollRestoration = _scrollRestoration === void 0 ? true : _scrollRestoration, _perPage = props.perPage, perPage = _perPage === void 0 ? 5 : _perPage, totalPage = props.totalPage, currentPage = props.currentPage;
    var pageInfos = common_usePagination(currentPage, totalPage, perPage);
    useScrollRestoration({
        ref: undefined,
        enabled: scrollRestoration
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationContent, {
            children: pageInfos.map(function(pageInfo) {
                switch(pageInfo.type){
                    case PaginationType.DOUBLE_PREVIOUS:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationDoublePrevious, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                    case PaginationType.PREVIOUS:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationPrevious, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                    case PaginationType.LINK:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationLink, {
                                isActive: pageInfo.isActive,
                                variant: pageInfo.isActive ? "active" : "default",
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page))),
                                children: pageInfo.page
                            })
                        }, "pagination-".concat(pageInfo.type, "-").concat(pageInfo.page));
                    case PaginationType.NEXT:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationNext, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                    case PaginationType.DOUBLE_NEXT:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationDoubleNext, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                }
            })
        })
    });
};
/* harmony default export */ var common_PaginationComponent = (PaginationComponent);


/***/ }),

/***/ 6329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98240);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);






var WithHyperLinkComponent = function(_param) {
    var children = _param.children, href = _param.href, _target = _param.target, target = _target === void 0 ? "_self" : _target, _rel = _param.rel, rel = _rel === void 0 ? "" : _rel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "href",
        "target",
        "rel"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            target: target
        }, props), {
            rel: rel,
            children: children
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WithHyperLinkComponent);


/***/ }),

/***/ 65844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ notFound_NotFoundTemplate; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/atom/icon/AlertWarningTriangle.tsx


var AlertWarningTriangle = function(param) {
    var _size = param.size, size = _size === void 0 ? 48 : _size, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "#FCC419" : _backgroundColor, _isFillBackground = param.isFillBackground, isFillBackground = _isFillBackground === void 0 ? true : _isFillBackground, _iconColor = param.iconColor, iconColor = _iconColor === void 0 ? "#FFFFFF" : _iconColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: isFillBackground ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    clipPath: "url(#clip0_2121_55018)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0001 0.0200806C23.0536 0.0200806 22.1254 0.281296 21.3178 0.774962C20.5103 1.26863 19.8546 1.97559 19.423 2.818L19.4154 2.83299L0.560651 40.5425C0.167088 41.3246 -0.0216433 42.1971 0.0150049 43.0721C0.0516959 43.9481 0.311687 44.8001 0.770288 45.5472C1.22889 46.2943 1.87088 46.9118 2.63528 47.341C3.39968 47.7703 4.26113 47.9969 5.13778 47.9996H5.143H42.8572H42.8623C43.739 47.9969 44.6006 47.7703 45.3648 47.341C46.1294 46.9118 46.7712 46.2943 47.23 45.5472C47.6887 44.8001 47.9486 43.9481 47.9853 43.0721C48.022 42.1971 47.8344 41.327 47.4408 40.5449L28.5849 2.83299L28.5773 2.818C28.1457 1.97559 27.49 1.26863 26.6824 0.774962C25.8748 0.281296 24.9467 0.0200806 24.0001 0.0200806Z",
                            fill: backgroundColor
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M26.143 17.1462C26.143 15.9627 25.1836 15.0034 24.0001 15.0034C22.8166 15.0034 21.8572 15.9627 21.8572 17.1462V27.4319C21.8572 28.6154 22.8166 29.5748 24.0001 29.5748C25.1836 29.5748 26.143 28.6154 26.143 27.4319V17.1462ZM24.0001 41.1463C25.8936 41.1463 27.4287 39.6113 27.4287 37.7177C27.4287 35.8241 25.8936 34.2891 24.0001 34.2891C22.1066 34.2891 20.5715 35.8241 20.5715 37.7177C20.5715 39.6113 22.1066 41.1463 24.0001 41.1463Z",
                            fill: iconColor
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2121_55018",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: iconColor
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    clipPath: "url(#clip0_2689_47859)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M23.4333 0.0483797C22.535 0.143823 21.7428 0.428175 20.9876 0.926261C20.27 1.3995 19.7601 1.93023 19.3087 2.67381C19.1186 2.98682 0.508477 40.2136 0.388016 40.5217C-0.112451 41.8017 -0.116656 43.2479 0.376419 44.5022C1.06412 46.2516 2.58021 47.5279 4.40583 47.8944C4.97384 48.0084 3.43137 48.0001 24.0037 47.9999C44.1245 47.9997 42.9752 48.0048 43.4973 47.9133C44.1444 47.7999 44.8183 47.5393 45.4035 47.176C46.2696 46.6384 46.9506 45.8894 47.4107 44.9685C47.7545 44.2804 47.9368 43.6074 47.9746 42.8874C47.9811 42.7629 47.9937 42.6565 48.0027 42.651C48.0116 42.6455 48.0188 42.5875 48.0186 42.5221C48.0185 42.4517 48.0118 42.4135 48.0024 42.4284C47.9933 42.4428 47.9813 42.3364 47.9743 42.1788C47.9499 41.6283 47.8293 41.0776 47.6116 40.5217C47.4907 40.2131 28.8799 2.98537 28.6908 2.67381C28.5065 2.37029 28.3466 2.14917 28.1284 1.8958C27.4297 1.08474 26.3976 0.44989 25.3437 0.183029C24.7635 0.0360917 24.0333 -0.0153835 23.4333 0.0483797ZM23.6925 4.27342C23.4038 4.34897 23.118 4.55184 22.9564 4.79594C22.8284 4.98925 4.33089 41.9966 4.27786 42.1654C4.22026 42.3488 4.21619 42.6862 4.26945 42.8641C4.39986 43.2995 4.74275 43.6324 5.18372 43.7519C5.30245 43.784 6.21739 43.7857 23.9997 43.7857C41.782 43.7857 42.697 43.784 42.8157 43.7519C43.2567 43.6324 43.5996 43.2995 43.73 42.8641C43.7832 42.6862 43.7792 42.3488 43.7216 42.1654C43.6685 41.9966 25.171 4.98925 25.043 4.79594C24.879 4.54817 24.5927 4.34688 24.2981 4.27225C24.1542 4.2358 23.8339 4.23642 23.6925 4.27342ZM23.7597 15.1704C23.4133 15.2033 23.0588 15.3396 22.7784 15.5478C22.267 15.9275 21.9689 16.4358 21.9077 17.032C21.8788 17.3134 21.8801 27.3459 21.9091 27.6137C21.9624 28.1071 22.1774 28.5366 22.5491 28.8925C22.9408 29.2674 23.3656 29.4461 23.9133 29.4664C24.5284 29.4892 25.0079 29.3107 25.4463 28.8955C25.8188 28.5429 26.0368 28.109 26.0904 27.6137C26.1193 27.3459 26.1206 17.3134 26.0917 17.032C26.0537 16.661 25.9253 16.3255 25.7114 16.0381C25.416 15.6411 25.0269 15.3627 24.5925 15.2376C24.4523 15.1972 24.0562 15.1432 23.9613 15.1515C23.9455 15.1529 23.8548 15.1614 23.7597 15.1704ZM23.6445 33.6982C22.1884 33.8345 20.9156 34.8255 20.4294 36.2017C20.2784 36.629 20.2182 36.9915 20.2177 37.476C20.2173 37.8559 20.2482 38.1098 20.3348 38.4381C20.7747 40.1052 22.2752 41.2609 23.9997 41.2609C25.8843 41.2609 27.4812 39.8791 27.7525 38.0136C27.7905 37.7522 27.7908 37.2085 27.7531 36.9434C27.5953 35.8331 26.9475 34.8422 25.9911 34.2482C25.3011 33.8196 24.4582 33.6221 23.6445 33.6982ZM0.00585938 42.5473C0.00585938 42.6159 0.00935377 42.644 0.013597 42.6097C0.0178594 42.5753 0.0178594 42.5192 0.013597 42.4849C0.00935377 42.4505 0.00585938 42.4786 0.00585938 42.5473Z",
                        fill: backgroundColor
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2689_47859",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: iconColor
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var icon_AlertWarningTriangle = (AlertWarningTriangle);

// EXTERNAL MODULE: ./src/constants/url.ts
var url = __webpack_require__(26093);
// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/components/templates/error/notFound/NotFoundTemplate.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 184px 0 230px 0;\n  svg {\n    margin-bottom: 32px;\n  }\n  & > h1 {\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 10px;\n\n    @media screen and (max-width: ",
        ") {\n      ",
        ";\n    }\n  }\n\n  & > span {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 24px;\n\n    @media screen and (max-width: ",
        ") {\n      ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: flex;\n  justify-content: center;\n  padding: 10px 16px;\n  width: fit-content;\n  border-radius: 8px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  margin-bottom: 12px;\n\n  &:hover {\n    cursor: pointer;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var NotFoundTemplate = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_AlertWarningTriangle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "페이지를 찾을 수 없습니다."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    "입력된 주소가 정확하지 않은 것 같아요.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " 상단 메뉴를 눌러 원하는 페이지로 이동하세요."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: !(0,RNPlugins/* isWebView */.vp)() ? url/* Urls.Introduce */.n.Introduce : common/* ROUTES.BOARD.HOME.path */.Z6.BOARD.HOME.path,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                    children: "홈 화면으로 이동"
                })
            })
        ]
    });
};
/* harmony default export */ var notFound_NotFoundTemplate = (NotFoundTemplate);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aeaa8be1-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI28SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray900;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI24SB;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
});
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-aeaa8be1-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.typography.UI16M;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray100;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});


/***/ }),

/***/ 71213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _components_molecules_LoginModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4329);
/* harmony import */ var _hooks_useModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98266);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74701);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10712);








var useAuthModal = function() {
    var canOverlayClick = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, isWritePage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showAuthModal = ref[0], setShowAuthModal = ref[1];
    var ref1 = (0,_hooks_useModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        campaign: "",
        content: "",
        buttonText: ""
    }), trackInfo = ref2[0], setTrackInfo = ref2[1];
    var isRouteBackPath = router.pathname.includes("/content/qna/write");
    var onClickCancel = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setShowAuthModal(false);
        closeModal();
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .isWebView */ .vp)() && isRouteBackPath) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .historyBack */ .$i)();
        }
    }, [
        closeModal,
        isRouteBackPath
    ]);
    /** for Webview  */ var onClickLogin = function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_LOGIN */ .nn.MOVE_TO_LOGIN);
            setShowAuthModal(false);
            closeModal();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (showAuthModal) {
            (0,_utils_logger__WEBPACK_IMPORTED_MODULE_6__/* .logger */ .kg)({
                eventName: "sns_login",
                pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_6__/* .getPageName */ .j0)(router)
            });
            if (!(0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .isWebView */ .vp)()) {
                showModal({
                    type: _types_modal__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_TYPE.BASIC */ .f.BASIC,
                    props: {
                        body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_LoginModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            isWritePage: isWritePage,
                            onClick: onClickCancel,
                            trackInfo: trackInfo
                        }),
                        onClickOverlay: canOverlayClick ? onClickCancel : undefined
                    }
                });
            } else {
                showModal({
                    type: _types_modal__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_TYPE.ALERT */ .f.ALERT,
                    props: {
                        title: "로그인이 필요해요",
                        message: "서비스 이용을 위해 로그인해 주세요.",
                        buttons: [
                            {
                                label: "닫기",
                                onClick: function() {
                                    return onClickCancel();
                                }
                            },
                            {
                                type: _types_modal__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_BUTTON_TYPE.PRIMARY */ .J.PRIMARY,
                                label: "로그인",
                                onClick: function() {
                                    return onClickLogin();
                                }
                            }, 
                        ]
                    }
                });
            }
        }
    }, [
        showAuthModal
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var close = function() {
            closeModal();
        };
        window.addEventListener("popstate", close);
        return function() {
            window.removeEventListener("popstate", close);
        };
    });
    return {
        setShowAuthModal: setShowAuthModal,
        setTrackInfo: setTrackInfo,
        trackInfo: trackInfo
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModal);


/***/ }),

/***/ 98266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22386);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81541);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var _recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11221);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74701);







var useModal = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilState)(_recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .modalState */ .e), 2), modals = ref[0], setModals = ref[1];
    var addModal = function(modal) {
        setModals(function(oldModals) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(oldModals).concat([
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, modal), {
                    index: oldModals.length + 1
                })
            ]);
        });
    };
    var showModal = function(param) {
        var type = param.type, props = param.props;
        switch(type){
            case _types_modal__WEBPACK_IMPORTED_MODULE_2__/* .MODAL_TYPE.BASIC */ .f.BASIC:
            default:
                addModal({
                    type: type,
                    props: props
                });
                break;
        }
    };
    var closeModal = function() {
        var tempModals = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(modals);
        tempModals.pop();
        setModals(tempModals);
    };
    return {
        isModalOpen: modals.length > 0,
        showModal: showModal,
        closeModal: closeModal
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useModal);


/***/ }),

/***/ 85180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useNavigate; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(98240);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/types/navigate.ts
var DoctornowWebViewType;
(function(DoctornowWebViewType) {
    DoctornowWebViewType["SafeAreaView"] = "SafeAreaView";
    DoctornowWebViewType["BottomSafeAreaView"] = "BottomSafeAreaView";
    DoctornowWebViewType["KeyboardAvoidingView"] = "KeyboardAvoidingView";
})(DoctornowWebViewType || (DoctornowWebViewType = {}));

// EXTERNAL MODULE: ./src/hooks/useNavigator.ts
var useNavigator = __webpack_require__(35613);
;// CONCATENATED MODULE: ./src/hooks/useNavigate.ts






/**
 * webview wrapper options
 * safeAreaView / bottomSafeAreaView / keyboardAvoidingView
 * @param webViewType DoctornowWebViewType
 * @default DoctornowWebViewType.BottomSafeAreaView
 *
 * webview options
 * @param scrollEnabled boolean
 * @default true
 *
 * @param bounces boolean
 * @default true
 *
 * @param keyboardDisplayRequiresUserAction boolean
 * @default true
 *
 * @param hideKeyboardAccessoryView boolean
 * @default false
 *
 * bottomSheet options
 * @param hasTelemedicineBottomSheet boolean
 * @default false
 */ var useNavigate = function() {
    var navigator = (0,useNavigator/* default */.Z)();
    var navigateToDietInjection = function() {
        return navigator.pushScreen({
            url: common/* ROUTES.FACE_TO_FACE.PREFERENCE_STEP.path */.Z6.FACE_TO_FACE.PREFERENCE_STEP.path
        });
    };
    var navigateToFindPharmacy = function() {
        return navigator.pushScreen({
            url: common/* ROUTES.PHARMACIES.PHARMACIES_FIND.pathName */.Z6.PHARMACIES.PHARMACIES_FIND.pathName
        });
    };
    var navigateToEmergencyContraceptive = function(param) {
        var categoryId = param.categoryId, type = param.type;
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.DOCTOR.F2F_LIST.appScreenName */.Z6.DOCTOR.F2F_LIST.appScreenName,
            params: {
                categoryId: categoryId,
                type: type
            }
        });
    };
    var navigateToQnaDetail = function(_param) {
        var questionPid = _param.questionPid, params = (0,_object_without_properties/* default */.Z)(_param, [
            "questionPid"
        ]);
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid),
            params: params
        });
    };
    var navigateToNps = function() {
        return navigator.pushScreen({
            url: common/* ROUTES.QNA.NPS.path */.Z6.QNA.NPS.path
        });
    };
    var navigateToHospitalSearch = function(params) {
        return navigator.pushScreen({
            url: common/* ROUTES.HOSPITAL.SEARCH.path */.Z6.HOSPITAL.SEARCH.path,
            params: params
        });
    };
    var navigateToFaceToFaceDiagnosisMap = function(params) {
        return navigator.pushScreen({
            url: common/* ROUTES.FACE_TO_FACE.DIAGNOSIS_MAP.path */.Z6.FACE_TO_FACE.DIAGNOSIS_MAP.path,
            params: params
        });
    };
    var navigateToFaceToFaceDoctorList = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.DOCTOR.F2F_LIST.appScreenName */.Z6.DOCTOR.F2F_LIST.appScreenName,
            params: params
        });
    };
    var navigateToMagazineTagList = function(param) {
        var tagName = param.tagName;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.MAGAZINE.TAG.path */.Z6.MAGAZINE.TAG.path, "?tag=").concat(tagName)
        });
    };
    var navigateToHospitalDetail = function(param) {
        var hospitalPid = param.hospitalPid;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path, "/").concat(hospitalPid)
        });
    };
    var navigateToMagazineDetail = function(param) {
        var magazinePid = param.magazinePid;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazinePid)
        });
    };
    var navigateToQnaDetailWithJumpToQnaTab = function(_param) {
        var questionPid = _param.questionPid, params = (0,_object_without_properties/* default */.Z)(_param, [
            "questionPid"
        ]);
        return navigator.jumpToScreen({
            tabName: "QuickAnswerTab",
            url: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid),
            params: params
        });
    };
    var navigateHomeWithJumpToHomeTab = function(params) {
        return navigator.jumpToAppScreen({
            tabName: "HomeTab",
            screenName: common/* ROUTES.HOME.appScreenName */.Z6.HOME.appScreenName,
            params: params
        });
    };
    var navigateToTreatmentRequest = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.TREATMENT_REQUEST.TREATMENT_REQUEST.appScreenName */.Z6.TREATMENT_REQUEST.TREATMENT_REQUEST.appScreenName,
            params: params
        });
    };
    var navigateToCategorySelect = function() {
        return navigator.navigateAppScreen({
            screenName: "CategorySelectScreen"
        });
    };
    var navigateToFamilyRegister = function(params) {
        return navigator.pushScreen({
            url: common/* ROUTES.FAMILY.REGISTER.path */.Z6.FAMILY.REGISTER.path,
            params: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                webViewType: DoctornowWebViewType.KeyboardAvoidingView,
                keyboardDisplayRequiresUserAction: false,
                hideKeyboardAccessoryView: true
            })
        });
    };
    var navigateToMedicineDictionaryDetail = function(param) {
        var medicineDictionaryPid = param.medicineDictionaryPid, keyword = param.keyword;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.MEDICINE_DICTIONARY.DETAIL.path */.Z6.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(medicineDictionaryPid, "/").concat(encodeURIComponent(keyword))
        });
    };
    var navigateToDiseaseEncyclopediaDetail = function(param) {
        var diseaseEncyclopediaPid = param.diseaseEncyclopediaPid, keyword = param.keyword;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.DISEASE_ENCYCLOPEDIA.DETAIL.path */.Z6.DISEASE_ENCYCLOPEDIA.DETAIL.path, "/").concat(diseaseEncyclopediaPid, "/").concat(encodeURIComponent(keyword))
        });
    };
    var navigateToMagazineAuthorDetail = function(param) {
        var authorPublicId = param.authorPublicId;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.AUTHOR.DETAIL.path */.Z6.AUTHOR.DETAIL.path, "/").concat(authorPublicId)
        });
    };
    return {
        navigateToDietInjection: navigateToDietInjection,
        navigateToFindPharmacy: navigateToFindPharmacy,
        navigateToEmergencyContraceptive: navigateToEmergencyContraceptive,
        navigateToQnaDetail: navigateToQnaDetail,
        navigateToNps: navigateToNps,
        navigateToHospitalSearch: navigateToHospitalSearch,
        navigateToFaceToFaceDiagnosisMap: navigateToFaceToFaceDiagnosisMap,
        navigateToFaceToFaceDoctorList: navigateToFaceToFaceDoctorList,
        navigateToMagazineTagList: navigateToMagazineTagList,
        navigateToHospitalDetail: navigateToHospitalDetail,
        navigateToMagazineDetail: navigateToMagazineDetail,
        navigateToQnaDetailWithJumpToQnaTab: navigateToQnaDetailWithJumpToQnaTab,
        navigateHomeWithJumpToHomeTab: navigateHomeWithJumpToHomeTab,
        navigateToTreatmentRequest: navigateToTreatmentRequest,
        navigateToCategorySelect: navigateToCategorySelect,
        navigateToFamilyRegister: navigateToFamilyRegister,
        navigateToMedicineDictionaryDetail: navigateToMedicineDictionaryDetail,
        navigateToMagazineAuthorDetail: navigateToMagazineAuthorDetail,
        navigateToDiseaseEncyclopediaDetail: navigateToDiseaseEncyclopediaDetail
    };
};
/* harmony default export */ var hooks_useNavigate = (useNavigate);


/***/ }),

/***/ 35613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98240);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10712);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74735);






var NavigatorType;
(function(NavigatorType) {
    NavigatorType["PushScreen"] = "PUSH_SCREEN";
    NavigatorType["ReplaceScreen"] = "REPLACE_SCREEN";
    NavigatorType["PopToTop"] = "POP_TO_TOP";
    NavigatorType["Back"] = "BACK";
    NavigatorType["JumpTo"] = "JUMP_TO";
    NavigatorType["Navigate"] = "NAVIGATE";
})(NavigatorType || (NavigatorType = {}));
var useNavigator = function() {
    var _ref = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(), push = _ref.push, replace = _ref.replace, routerProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "push",
        "replace"
    ]);
    var query = routerProps.query;
    var pushScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.PushScreen,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var popToTopScreen = function(url, options) {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "?routeType=".concat(NavigatorType.PopToTop));
        }
        if (!url) {
            return;
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push(url);
    };
    var jumpToScreen = function(param, options) {
        var tabName = param.tabName, params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                tabName: tabName,
                routeType: NavigatorType.JumpTo,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var replaceScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.ReplaceScreen,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return replace("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var navigateScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.Navigate,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return replace("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var back = function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", (0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)({
                routeType: NavigatorType.Back
            }));
        }
        return window.history.back();
    };
    var pushAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var jumpToAppScreen = function(param) {
        var tabName = param.tabName, screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_TAB_HOME */ .nn.MOVE_TO_TAB_HOME, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            tabName: tabName,
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var replaceAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var navigateAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.NAVIGATE_TO_PAGE */ .nn.NAVIGATE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, routerProps), {
        query: query,
        push: push,
        pushScreen: pushScreen,
        popToTopScreen: popToTopScreen,
        jumpToScreen: jumpToScreen,
        replace: replace,
        replaceScreen: replaceScreen,
        navigateScreen: navigateScreen,
        pushAppScreen: pushAppScreen,
        jumpToAppScreen: jumpToAppScreen,
        replaceAppScreen: replaceAppScreen,
        navigateAppScreen: navigateAppScreen,
        back: back
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useNavigator);


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/StickyAppHeader/index.tsx + 4 modules
var StickyAppHeader = __webpack_require__(77314);
// EXTERNAL MODULE: ./src/components/templates/error/notFound/NotFoundTemplate.tsx + 1 modules
var NotFoundTemplate = __webpack_require__(65844);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/shared/icons/instagramIcon.svg
var _circle, _rect, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgInstagramIcon = function SvgInstagramIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F00075"
  })), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    x: 9,
    y: 9,
    width: 18,
    height: 18,
    rx: 5,
    stroke: "#fff",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/react.createElement("circle", {
    cx: 23.25,
    cy: 12.75,
    r: 1.25,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/react.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 4,
    stroke: "#fff",
    strokeWidth: 2
  })));
};
/* harmony default export */ var instagramIcon = (SvgInstagramIcon);
;// CONCATENATED MODULE: ./src/shared/icons/naverBlogIcon.svg
var naverBlogIcon_circle, _path, _path2;
function naverBlogIcon_extends() { return naverBlogIcon_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, naverBlogIcon_extends.apply(null, arguments); }

var SvgNaverBlogIcon = function SvgNaverBlogIcon(props) {
  return /*#__PURE__*/react.createElement("svg", naverBlogIcon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), naverBlogIcon_circle || (naverBlogIcon_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#36B44A"
  })), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M25.016 10H10.378A3.386 3.386 0 0 0 7 13.392v8.047c0 1.873 1.51 3.39 3.378 3.39h5.044l1.72 2.8s.018.036.055.081a.58.58 0 0 0 .5.29.581.581 0 0 0 .498-.286.378.378 0 0 0 .06-.085l1.718-2.8h5.042a3.387 3.387 0 0 0 3.382-3.39v-8.047A3.389 3.389 0 0 0 25.015 10",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M11.752 15.896s-.585 0-1.116.518v-2.079H9.328v5.457h1.322v-.428s.313.565 1.101.565c0 0 1.845-.07 1.845-2.041 0 0-.067-1.993-1.845-1.993m-.288 2.88a.84.84 0 1 1 0-1.682.841.841 0 1 1 0 1.681ZM14.019 14.21v1.265s.595-.027.595 1.088v3.229h1.264v-3.529s.054-2.053-1.86-2.053ZM18.966 15.915s-2.166 0-2.166 2.02c0 0-.068 1.995 2.166 1.995 0 0 2.214-.003 2.214-1.995 0 0 .073-2.02-2.214-2.02Zm0 2.86a.84.84 0 1 1 0-1.682c.468 0 .841.376.841.842 0 .466-.375.84-.84.84ZM24.794 16.042v.372s-.377-.5-1.1-.5c0 0-1.853-.08-1.853 2.006 0 0-.02 1.944 1.802 1.944 0 0 .742.029 1.15-.5v.306s.093.957-.834.957h-.316v1.16h.51s1.915.02 1.915-2.045V16.04h-1.274v.001Zm-.782 2.732a.841.841 0 1 1-.001-1.682.841.841 0 0 1 0 1.683Z",
    fill: "#F47626"
  })));
};
/* harmony default export */ var naverBlogIcon = (SvgNaverBlogIcon);
;// CONCATENATED MODULE: ./src/shared/icons/threadIcon.svg
var threadIcon_circle, _g, _defs;
function threadIcon_extends() { return threadIcon_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, threadIcon_extends.apply(null, arguments); }

var SvgThreadIcon = function SvgThreadIcon(props) {
  return /*#__PURE__*/react.createElement("svg", threadIcon_extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), threadIcon_circle || (threadIcon_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#020202"
  })), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#threadIcon_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M18.06 28h-.193c-.063 0-.128-.002-.191-.005l-.191-.007-.19-.01a6.467 6.467 0 0 1-.187-.014c-.061-.005-.125-.01-.186-.017-.061-.006-.124-.012-.186-.02-.061-.009-.123-.015-.184-.022l-.182-.026a5.68 5.68 0 0 1-.18-.029c-.06-.01-.122-.02-.181-.032-.06-.012-.12-.022-.18-.036l-.176-.037c-.06-.012-.118-.027-.176-.04a6.592 6.592 0 0 1-.173-.045c-.058-.015-.116-.03-.172-.048-.058-.017-.114-.032-.17-.05a6.39 6.39 0 0 0-.168-.053l-.167-.056-.167-.06a6.422 6.422 0 0 1-.163-.063c-.054-.022-.108-.042-.161-.066l-.16-.068-.157-.072a4.317 4.317 0 0 1-.156-.074 4.281 4.281 0 0 1-.155-.079c-.05-.027-.101-.052-.152-.081-.051-.027-.1-.056-.151-.084-.05-.027-.1-.057-.15-.086a4.08 4.08 0 0 1-.145-.09 4.17 4.17 0 0 1-.143-.094l-.142-.097c-.048-.032-.093-.066-.14-.1-.046-.034-.094-.068-.137-.102-.044-.034-.092-.07-.135-.106a4.02 4.02 0 0 1-.134-.108l-.131-.113c-.044-.037-.086-.076-.128-.115l-.126-.118c-.043-.039-.083-.08-.123-.12l-.121-.124-.12-.128-.115-.13-.114-.135c-.037-.044-.074-.09-.11-.136l-.11-.14-.104-.142a10.5 10.5 0 0 1-.298-.447l-.095-.155a7.122 7.122 0 0 1-.265-.485c-.028-.056-.056-.11-.082-.168a16.363 16.363 0 0 0-.08-.17l-.075-.174-.073-.176a5.62 5.62 0 0 1-.07-.18c-.023-.062-.046-.121-.067-.184l-.063-.187a7.692 7.692 0 0 1-.06-.19c-.02-.062-.038-.127-.058-.191a6.41 6.41 0 0 1-.082-.308c-.009-.037-.02-.075-.028-.112l-.026-.112-.027-.113-.024-.112a2.195 2.195 0 0 1-.023-.114l-.023-.114-.02-.113-.022-.114c-.007-.038-.012-.077-.02-.114l-.017-.114-.017-.114-.016-.114-.016-.114a2.532 2.532 0 0 1-.014-.114l-.014-.114c-.005-.037-.009-.076-.012-.114l-.012-.114-.011-.114-.01-.113-.01-.114-.008-.114-.007-.114-.007-.114c-.004-.038-.004-.077-.005-.114 0-.037-.004-.075-.006-.114l-.003-.112c0-.038-.002-.075-.004-.113l-.001-.112c-.002-.037 0-.074 0-.112v-.442l.001-.109c0-.035 0-.073.004-.109l.003-.108c0-.036.002-.072.004-.107 0-.036.003-.072.005-.108 0-.035.004-.071.005-.105l.006-.105c.001-.036.003-.07.007-.106.001-.034.005-.07.007-.104l.007-.103.009-.102.008-.102.01-.1.01-.101.01-.099.01-.098.011-.097c.004-.032.007-.065.012-.095.004-.033.01-.063.013-.096l.012-.093c.003-.03.009-.061.012-.092l.014-.092c.006-.03.009-.06.014-.09.006-.03.01-.06.014-.088.006-.03.01-.06.014-.089l.016-.086.016-.085.016-.084.015-.081.016-.082c.005-.03.013-.06.02-.09a303.33 303.33 0 0 1 .042-.185l.022-.094.025-.095.026-.095.027-.097c.008-.033.019-.065.028-.097.008-.032.019-.065.03-.097l.031-.099.032-.098.033-.1c.01-.035.023-.067.035-.1l.037-.101c.012-.034.024-.068.037-.1l.038-.102.04-.103.043-.101.042-.103c.014-.034.03-.068.043-.102l.046-.102.047-.102c.016-.034.032-.068.05-.102.015-.034.033-.068.049-.102.015-.034.033-.068.05-.102l.053-.102.054-.102.055-.102.056-.1.058-.1c.019-.034.038-.067.06-.1.019-.035.04-.067.06-.101.022-.034.043-.066.062-.099l.063-.098.065-.099.067-.097.068-.097.068-.095c.023-.032.048-.063.07-.095l.072-.094.074-.093.075-.092.078-.092c.026-.03.05-.06.077-.09.026-.03.052-.06.079-.088l.08-.089.083-.086a4.24 4.24 0 0 1 .084-.085l.086-.084c.03-.027.058-.056.086-.083l.087-.082.09-.08.091-.078.093-.076.095-.075c.031-.026.063-.05.094-.073l.097-.072c.033-.023.065-.045.098-.07l.1-.067.102-.067c.033-.022.068-.042.103-.064l.103-.061c.035-.02.07-.041.106-.06l.107-.058.114-.06.114-.057c.038-.019.077-.037.115-.054.039-.02.077-.036.116-.053l.116-.051c.038-.017.077-.034.117-.05l.118-.047.117-.046.118-.044c.038-.016.079-.03.119-.043l.12-.04.118-.041.12-.04.119-.037.119-.036.12-.034.118-.032.12-.03.119-.03.12-.027.118-.025.12-.026.119-.023c.038-.009.08-.016.119-.022l.12-.02c.04-.008.078-.014.119-.02l.119-.018.119-.017.117-.016c.039-.005.08-.01.118-.013l.117-.014c.039-.005.08-.008.118-.012l.116-.01.115-.01.116-.009.114-.006.114-.007.114-.005c.038-.002.075-.004.112-.004.037 0 .076-.001.112-.003.037 0 .074 0 .11-.002.038-.002.075 0 .111 0h.218c.037 0 .072 0 .107.002l.107.003c.035 0 .07.004.105.004.035 0 .07.003.105.005l.103.005.102.007c.034.001.069.005.102.007l.1.008.098.009.098.01.097.01a1.8 1.8 0 0 1 .094.012l.093.012c.032.003.062.008.091.013l.092.014.089.014.088.015.086.015c.028.005.056.01.084.017l.082.017.104.022c.033.007.068.016.101.022l.102.024c.033.009.067.015.1.024l.1.025.098.026.098.025c.034.009.065.017.097.028l.096.027c.032.008.063.019.095.029.031.01.063.018.095.029l.092.029c.03.008.062.02.093.03l.091.03c.03.011.062.021.092.033l.09.032c.029.01.059.022.088.034.03.012.06.022.088.034.03.012.058.024.088.034l.088.036.085.036.086.037.084.038c.029.012.057.025.085.039.028.013.056.025.082.039.028.013.054.027.082.039.028.012.055.027.083.04l.08.042c.027.013.055.027.081.042l.08.043c.025.013.052.028.078.044.026.015.053.029.077.044l.077.046.077.046.076.046.075.047.074.048.074.05.073.049.072.05.072.052.07.052.07.053.07.054c.023.02.046.036.069.055l.068.056a337.52 337.52 0 0 0 .135.114c.023.018.044.039.067.058.023.018.044.039.065.06.02.02.043.038.064.059l.065.06.063.062c.021.02.043.04.064.063l.063.063c.02.02.042.042.061.065l.061.064.062.066.06.067c.019.022.04.044.059.068l.06.068.058.07c.019.023.038.045.057.07l.058.07.06.075.058.075.058.075c.019.026.036.05.056.075l.054.075.053.074c.017.026.035.05.05.075.016.026.034.05.051.075.016.026.034.05.05.075.015.025.031.05.047.073.016.024.031.05.047.073.016.024.03.05.046.073l.044.073.042.072.042.071c.014.024.028.048.04.072.014.023.026.047.039.07.012.025.026.048.038.07l.037.07.037.068.035.068a.809.809 0 0 1 .033.068c.01.022.023.045.034.067a19.919 19.919 0 0 0 .06.13l.03.065c.011.02.02.043.029.063l.028.063.026.061.026.06c.01.02.016.039.025.06l.023.057c.007.019.016.037.023.058l.02.056.022.054c.007.02.014.036.019.053a.621.621 0 0 0 .02.053l.017.05c.005.018.012.035.017.05l.016.048.016.046.016.046.014.044c.005.013.008.029.014.042.003.014.008.027.012.041.003.014.009.027.012.04l.01.037.011.035.01.034.01.033.008.03c.004.01.005.019.007.03.002.01.006.018.007.026l.007.026.006.024.005.02c0 .007.003.014.005.019 0 .006.004.012.004.017l.003.015c0 .005.002.008.004.014l.001.01c0 .003 0 .007.002.008v.012l-.026.005-.026.005-.027.006-.026.005-.026.005-.027.005-.026.005-.026.005-.027.005-.026.005-.026.005-.027.005-.026.006-.026.005-.026.005-.027.005-.026.005-.026.005-.027.005-.026.005-.026.005-.026.005-.027.005-.026.006-.026.005-.027.005-.026.005-.026.005-.027.005-.026.005-.026.005-.026.005-.027.006-.026.005-.026.005-.027.005-.026.005-.026.005-.027.005-.026.005-.026.005-.026.005-.027.006-.026.005-.026.005-.027.005-.026.005-.026.005-.027.005-.026.005-.026.005-.026.006-.027.005-.026.005-.026.005-.027.005-.026.005-.026.005-.027.005-.026.005-.026.005-.026.006-.027.005-.026.005.014-.004.014-.003h.014l.014-.005h.014l.014-.005.014-.004h.014l.014-.005.014-.003.014-.004.014-.003h.014l.014-.005.014-.004h.014l.014-.005.014-.003.014-.003.014-.004h.014l.014-.005.015-.003h.014l.014-.005h.014l.014-.006.014-.003h.014l.014-.005.014-.003h.014l.014-.005h.014l.014-.006.014-.003h.014l.014-.005.014-.003.014-.004.014-.003h.014l.014-.005.014-.004h.014l.014-.005.014-.003.014-.004.014-.003h.014l.014-.005h.014l.014-.005.014-.004h.014l.014-.005h.014l.015-.005h.014l.014-.005.014-.003h.014l.014-.006-.014.004-.015.003-.014.004-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.004-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.004-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.004-.015.003-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.004-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.003-.014.004-.014.003-.014.004v-.016c0-.003 0-.005-.002-.008 0-.003 0-.007-.002-.01a.032.032 0 0 0-.003-.012l-.004-.014-.003-.015-.005-.017a.275.275 0 0 1-.006-.019c0-.007-.003-.013-.005-.02a.433.433 0 0 1-.005-.022l-.007-.024c-.004-.009-.005-.017-.007-.024-.002-.008-.006-.017-.007-.025-.004-.009-.005-.02-.009-.028l-.009-.029-.009-.03-.01-.032-.01-.033-.011-.034c-.004-.012-.007-.024-.012-.035-.004-.012-.01-.024-.013-.036a.334.334 0 0 0-.014-.038l-.014-.039-.014-.039-.015-.04-.016-.043c-.006-.014-.01-.029-.018-.043L25.058 14c-.006-.015-.013-.029-.018-.044l-.02-.046-.018-.046-.021-.048-.022-.047a.602.602 0 0 0-.022-.05l-.023-.049-.023-.05-.024-.052c-.01-.017-.018-.034-.025-.052-.007-.02-.017-.036-.026-.053-.01-.017-.018-.036-.027-.053a.826.826 0 0 0-.028-.054c-.008-.019-.019-.036-.028-.055-.01-.018-.019-.037-.03-.054l-.03-.056-.03-.056-.032-.056-.034-.056c-.01-.02-.023-.038-.033-.058-.01-.02-.023-.04-.035-.058l-.037-.058-.037-.058c-.012-.018-.024-.039-.038-.058-.013-.018-.027-.039-.039-.059-.012-.02-.026-.04-.04-.06l-.04-.059-.043-.06a1.28 1.28 0 0 0-.043-.06c-.015-.02-.03-.038-.044-.059-.014-.02-.03-.039-.046-.06l-.046-.059-.047-.06-.045-.055c-.016-.019-.03-.038-.046-.055-.016-.018-.032-.035-.046-.054-.015-.019-.031-.036-.047-.054l-.047-.053-.048-.053-.047-.05a1.222 1.222 0 0 0-.05-.052 1.285 1.285 0 0 1-.048-.05c-.016-.018-.034-.033-.05-.05-.015-.017-.033-.032-.048-.05a.656.656 0 0 0-.051-.047c-.018-.015-.034-.032-.051-.048-.018-.015-.033-.03-.05-.047-.018-.017-.036-.03-.052-.046l-.052-.046-.053-.044-.053-.044c-.017-.016-.035-.03-.054-.045l-.054-.042-.055-.043c-.017-.013-.036-.027-.056-.04l-.056-.041-.056-.041-.056-.04-.058-.038-.058-.04-.058-.037c-.019-.012-.038-.025-.06-.037l-.059-.036-.06-.036-.06-.035c-.022-.012-.041-.024-.062-.034l-.063-.034-.063-.034c-.021-.012-.043-.023-.064-.033l-.064-.032a.754.754 0 0 1-.065-.032l-.065-.03c-.021-.011-.044-.021-.067-.031l-.066-.031a1.174 1.174 0 0 0-.069-.029l-.068-.029-.069-.029a.857.857 0 0 0-.07-.027l-.07-.027-.07-.027a3.224 3.224 0 0 0-.072-.026l-.072-.025-.073-.026a1.233 1.233 0 0 0-.074-.024l-.075-.024-.076-.023c-.024-.009-.05-.016-.075-.023-.026-.006-.051-.015-.077-.022-.027-.006-.051-.015-.078-.022a1.367 1.367 0 0 1-.078-.022l-.08-.02-.08-.02-.08-.021a1.17 1.17 0 0 0-.083-.019l-.082-.018c-.029-.007-.056-.012-.083-.02l-.084-.018-.074-.015-.075-.014-.077-.013-.077-.014c-.027-.003-.053-.008-.08-.012l-.078-.012-.08-.01a10.39 10.39 0 0 0-.083-.01l-.083-.01-.084-.009-.084-.008a1.353 1.353 0 0 0-.086-.007l-.086-.007-.087-.005-.088-.005c-.03-.002-.06-.004-.09-.004s-.06-.001-.089-.003l-.091-.003c-.03 0-.061 0-.091-.002h-.37c-.032 0-.063 0-.095.002-.032 0-.063.001-.095.003l-.094.003c-.032 0-.063.004-.095.006l-.096.006a1.836 1.836 0 0 1-.097.007 1.848 1.848 0 0 0-.096.009l-.097.008-.096.01-.097.01c-.031.004-.065.007-.096.012-.033.004-.065.009-.098.012l-.098.014-.099.015-.098.016c-.033.005-.065.01-.098.017a1.973 1.973 0 0 1-.098.017l-.098.018-.099.02-.098.021-.098.022a1.579 1.579 0 0 0-.096.024c-.032.008-.065.015-.097.024l-.096.025-.097.026-.096.027a2.11 2.11 0 0 0-.097.029l-.096.03-.095.031c-.031.01-.063.02-.094.032-.032.01-.063.022-.095.034l-.095.034-.093.036a2.071 2.071 0 0 0-.092.037l-.093.038c-.03.014-.062.025-.092.04-.03.013-.061.026-.09.04l-.092.042c-.03.014-.06.03-.09.043l-.089.044c-.03.015-.06.03-.088.046-.03.015-.06.03-.087.048l-.086.049a3.62 3.62 0 0 1-.086.05l-.084.054c-.028.017-.055.035-.083.054a2.398 2.398 0 0 0-.16.117l-.078.06-.077.061c-.026.02-.051.043-.076.063-.024.022-.049.042-.073.065l-.074.066a2.504 2.504 0 0 0-.072.068c-.024.022-.047.046-.07.07l-.068.07-.069.07-.066.074-.065.073-.063.075-.063.075-.062.076-.06.077c-.019.025-.038.052-.059.078-.02.025-.038.053-.058.078-.02.026-.038.053-.056.08-.02.027-.037.053-.054.08l-.055.08a37.38 37.38 0 0 0-.103.163c-.018.027-.033.054-.05.082-.019.027-.034.054-.05.081l-.047.082-.048.083c-.016.027-.03.055-.045.083-.016.028-.03.055-.044.084l-.044.083c-.016.029-.028.055-.042.083a1.21 1.21 0 0 0-.04.084l-.04.083-.04.082a29.3 29.3 0 0 1-.036.081l-.037.082-.035.081a1.522 1.522 0 0 0-.033.082c-.01.027-.023.054-.034.08l-.031.08c-.01.027-.021.053-.03.08-.009.027-.02.053-.03.078l-.028.078a23.066 23.066 0 0 0-.077.228l-.024.075-.023.073-.021.071-.021.072-.02.07a.794.794 0 0 1-.019.067l-.018.069-.015.066-.016.064-.014.063-.014.062-.012.06c-.006.021-.01.045-.014.069-.006.024-.01.047-.014.071-.006.024-.01.048-.014.072-.006.023-.01.049-.013.073-.003.025-.008.049-.012.074-.003.026-.009.051-.012.077-.004.025-.01.051-.013.076l-.012.079-.012.08-.01.081-.011.082a11.05 11.05 0 0 0-.01.083l-.011.085-.01.085a1.497 1.497 0 0 0-.01.087l-.008.087c-.004.029-.005.06-.009.088-.003.029-.005.06-.009.088l-.007.09-.007.09-.007.092c-.002.031-.003.062-.007.092l-.005.094-.005.093c0 .033-.004.063-.006.096a1.682 1.682 0 0 0-.003.095c0 .032-.002.064-.004.097l-.003.097c0 .032-.002.064-.004.096l-.001.1v.595l.001.101c0 .034.002.068.004.102l.003.102c0 .034.004.068.006.102l.005.102.005.102.007.102.007.102.009.102.009.102.01.102.01.102.013.102.012.102.014.102c.006.034.01.069.014.103l.016.102.016.101c.005.035.01.069.017.102l.018.102c.005.035.012.069.02.102.006.035.011.069.019.1l.02.101.022.1.022.1c.01.035.016.067.023.101.007.034.016.066.025.099l.026.098.026.099.028.097.029.097c.01.032.019.064.03.095l.03.095.03.094.034.091c.01.031.023.062.033.092.01.03.023.062.035.09l.035.09.037.089.037.088c.012.03.025.058.039.087l.038.087.04.085.043.085.042.083.043.082.044.081c.014.028.03.055.046.08l.045.08.048.078.047.079.05.076c.015.026.033.051.048.077l.051.074.053.074.052.073c.018.023.035.047.055.071l.054.072c.02.023.037.047.056.07.02.023.037.045.056.069l.058.068c.02.022.039.044.058.068l.06.066.06.065.06.064.064.063.063.063.065.062c.02.02.044.04.065.06.02.021.043.04.066.06.023.02.044.04.067.058.023.019.045.04.068.058l.069.056.07.056.07.055.072.054.074.053.073.05.075.052.076.049c.025.015.05.032.077.05.026.016.05.032.077.047l.08.047c.025.016.052.031.078.046.026.016.053.03.08.044l.081.045c.028.015.055.029.083.042l.082.043.084.04c.028.014.056.028.086.041l.086.04c.028.013.058.025.088.037.033.014.066.029.1.042l.1.041.1.04c.033.011.066.025.101.037l.102.035.102.034c.033.012.068.023.101.033l.104.03.103.03c.035.01.069.018.104.026l.103.026.104.025c.033.009.07.016.105.024l.105.022.105.02c.035.008.07.014.105.02l.106.016.105.017a261.74 261.74 0 0 0 .21.03l.105.011c.036.004.07.009.106.012a385.852 385.852 0 0 0 .21.019l.105.008c.035.002.07.006.105.007l.104.005c.035 0 .07.004.103.005.035 0 .069.002.104.004.035 0 .068 0 .103.002h.309c.033 0 .068 0 .102-.002l.101-.004a939900427117.484 939900427117.484 0 0 1 .2-.009c.033 0 .067-.003.1-.004l.098-.007.098-.007.099-.008c.033-.004.065-.005.096-.009l.097-.01.094-.01.095-.012.093-.012.093-.014.09-.013.092-.014.09-.015.089-.015c.03-.006.06-.01.088-.017a1.31 1.31 0 0 1 .087-.017l.086-.018.084-.018.084-.019.083-.019.08-.02.08-.02.078-.02.078-.021a.963.963 0 0 0 .075-.022c.024-.007.049-.016.073-.022.025-.007.05-.016.074-.022l.072-.023c.025-.006.047-.015.072-.023l.072-.026a.845.845 0 0 0 .07-.027l.07-.027c.023-.01.047-.019.07-.03l.07-.03.07-.03c.023-.01.046-.023.07-.033.025-.01.046-.022.069-.034l.068-.034.069-.035.068-.036.067-.038c.023-.011.044-.025.066-.039l.067-.039.065-.04.065-.041.065-.043.063-.042c.02-.016.042-.03.063-.045l.063-.044c.021-.015.042-.03.061-.046l.062-.046a.812.812 0 0 0 .06-.047l.059-.048c.02-.015.039-.032.06-.05l.057-.049c.02-.016.04-.032.058-.049l.056-.05.057-.052a1.59 1.59 0 0 0 .054-.05c.017-.018.037-.035.054-.054l.053-.052.052-.055c.018-.018.035-.035.051-.054l.051-.054c.016-.02.034-.038.05-.055l.047-.056a23.477 23.477 0 0 0 .092-.112l.046-.058c.016-.02.03-.037.044-.058l.042-.058.042-.057c.014-.02.026-.04.04-.058.015-.019.027-.04.039-.06l.039-.06.036-.059c.013-.02.025-.039.035-.06l.035-.059.034-.06a1.8 1.8 0 0 1 .031-.059c.01-.02.021-.04.03-.061.01-.02.02-.04.028-.061.009-.02.02-.041.028-.061.01-.02.018-.041.027-.062a.869.869 0 0 0 .024-.06l.023-.062.021-.061.021-.061c.007-.02.012-.041.02-.062l.017-.06.016-.062.019-.078.018-.079.015-.076c.006-.025.009-.051.014-.076l.013-.077.01-.075.009-.075.009-.074.007-.074.005-.073.003-.073c.002-.025 0-.047.002-.071v-.143c0-.024 0-.046-.002-.07l-.003-.07c0-.023-.004-.045-.005-.067l-.007-.068a.88.88 0 0 0-.01-.069c-.003-.022-.004-.044-.008-.066l-.01-.066-.013-.066a.72.72 0 0 0-.014-.065l-.014-.065-.016-.063-.017-.062a.839.839 0 0 0-.02-.063l-.02-.061-.021-.062-.023-.061c-.007-.02-.016-.04-.025-.06l-.026-.059a1.909 1.909 0 0 0-.026-.058l-.029-.058c-.008-.018-.019-.037-.03-.057a.896.896 0 0 1-.03-.056l-.03-.057a.58.58 0 0 0-.034-.054c-.01-.019-.023-.036-.035-.054l-.035-.055-.037-.053c-.012-.017-.024-.035-.038-.052l-.039-.051-.04-.051-.043-.05-.041-.049c-.015-.017-.03-.032-.044-.05a1.114 1.114 0 0 0-.046-.047 1.176 1.176 0 0 1-.046-.047l-.047-.046-.049-.046a1.151 1.151 0 0 0-.05-.044l-.05-.045-.052-.044a1.21 1.21 0 0 0-.053-.042l-.054-.043a1.408 1.408 0 0 0-.057-.04c-.019-.014-.036-.028-.056-.041-.019-.014-.038-.028-.058-.04l-.06-.039a3.075 3.075 0 0 0-.059-.037l-.061-.038a1.146 1.146 0 0 1-.062-.037l-.063-.036c-.003.03-.008.058-.014.087-.005.029-.008.058-.014.085l-.015.085-.016.084c-.006.027-.01.056-.018.083a1.144 1.144 0 0 0-.017.083c-.006.029-.013.055-.02.082l-.019.081-.02.08-.022.08a1.004 1.004 0 0 1-.023.078l-.023.078-.024.079-.025.076-.026.077a3.183 3.183 0 0 1-.026.075l-.028.074-.028.073a1.18 1.18 0 0 1-.03.074l-.03.071-.031.071-.032.07c-.01.024-.021.046-.033.07-.01.024-.023.046-.034.068a1.22 1.22 0 0 1-.035.068l-.035.066-.035.067c-.012.022-.024.044-.037.064l-.037.065-.038.063-.039.063-.04.06-.04.062-.042.06-.043.059c-.014.019-.028.04-.043.058l-.044.056-.044.056c-.016.019-.03.037-.046.054-.015.02-.031.036-.045.055l-.047.053-.048.052c-.016.017-.031.034-.049.051l-.05.051c-.015.017-.032.033-.05.05l-.05.047c-.018.015-.036.032-.052.048-.015.015-.035.03-.052.046l-.053.046-.054.044-.055.042c-.017.014-.036.03-.056.043l-.056.04-.056.041c-.017.014-.038.026-.058.04a1.11 1.11 0 0 1-.058.037c-.019.012-.038.025-.06.037l-.059.036c-.02.012-.04.024-.06.034l-.06.034-.062.032-.063.031-.063.03-.064.03-.096.04c-.032.014-.065.026-.096.04-.034.011-.065.025-.099.035-.033.01-.066.024-.098.034l-.1.032-.1.03-.1.027-.101.025c-.035.009-.069.015-.102.022l-.102.02c-.033.007-.068.012-.103.02l-.104.015c-.035.005-.068.01-.103.013-.035.003-.068.009-.104.012-.035.003-.068.007-.103.009-.035.001-.068.005-.103.006l-.104.005c-.035 0-.068.002-.103.004h-.207c-.035 0-.069-.002-.104-.004l-.103-.005c-.035-.001-.068-.005-.103-.008l-.102-.01c-.034-.004-.069-.007-.102-.012l-.102-.014-.101-.015-.1-.017-.1-.02c-.034-.007-.067-.014-.1-.023l-.098-.023-.099-.026-.096-.027a107.375 107.375 0 0 1-.191-.06c-.032-.01-.063-.022-.095-.034l-.093-.035a1.436 1.436 0 0 1-.09-.038 2.1 2.1 0 0 1-.092-.039l-.09-.04a1.395 1.395 0 0 1-.087-.043c-.03-.014-.058-.03-.086-.044l-.086-.046-.084-.048c-.028-.015-.054-.032-.083-.05a3.336 3.336 0 0 1-.08-.05l-.079-.053-.077-.054c-.025-.02-.051-.038-.076-.056l-.073-.058a2.582 2.582 0 0 1-.21-.184c-.023-.02-.044-.043-.067-.065l-.065-.066a1.13 1.13 0 0 1-.062-.068l-.06-.07-.057-.071-.056-.071c-.018-.024-.035-.05-.053-.073a1.154 1.154 0 0 1-.05-.075l-.05-.077c-.015-.025-.031-.05-.045-.078l-.044-.08-.023-.044a.546.546 0 0 0-.023-.044l-.02-.045-.022-.046a.528.528 0 0 1-.019-.045c-.007-.016-.012-.031-.02-.046l-.017-.046-.017-.046c-.006-.015-.01-.03-.018-.046l-.016-.046-.015-.046a.372.372 0 0 1-.014-.047l-.014-.048a.396.396 0 0 1-.013-.048l-.012-.047c-.004-.016-.007-.033-.012-.048l-.01-.047-.011-.048a.441.441 0 0 1-.01-.048c-.003-.015-.004-.032-.008-.047l-.007-.048-.007-.047-.005-.048-.005-.048c0-.015-.004-.032-.006-.047l-.003-.048a.448.448 0 0 0-.004-.047c0-.016 0-.033-.002-.048v-.238c0-.015 0-.032.002-.048 0-.015.002-.032.004-.047l.003-.048c0-.015.004-.032.006-.048l.005-.047.005-.048.007-.047c.004-.016.005-.033.007-.048a.468.468 0 0 1 .009-.048c.003-.015.005-.032.009-.047l.01-.048.01-.047.011-.048a.433.433 0 0 1 .013-.046.459.459 0 0 0 .012-.046.446.446 0 0 1 .014-.046l.014-.046.016-.046.015-.046.016-.045a.479.479 0 0 1 .018-.046c.005-.016.012-.03.017-.044a.347.347 0 0 1 .02-.045l.019-.044.02-.044c.004-.015.013-.03.02-.044l.021-.045c.007-.013.014-.029.023-.042l.023-.043a.547.547 0 0 1 .024-.042c.01-.014.016-.029.025-.043l.017-.028.018-.03c.007-.01.012-.02.02-.03a.304.304 0 0 0 .019-.03l.02-.031.023-.033.023-.032a.384.384 0 0 1 .025-.032c.008-.01.015-.022.024-.032l.027-.034.026-.034a.468.468 0 0 1 .028-.034.494.494 0 0 0 .028-.035l.03-.034a.62.62 0 0 1 .031-.034l.032-.034a.636.636 0 0 1 .033-.034.648.648 0 0 1 .035-.035l.035-.036.037-.036a.798.798 0 0 1 .039-.035l.038-.036.04-.036.043-.035c.014-.012.028-.024.042-.034a.801.801 0 0 1 .044-.034.443.443 0 0 1 .045-.034l.046-.034.047-.034c.016-.012.032-.023.05-.034.015-.012.033-.023.05-.034a.877.877 0 0 1 .05-.033l.053-.032.055-.032c.017-.01.037-.023.056-.033.02-.01.038-.02.056-.032.018-.012.039-.02.058-.03l.06-.031.06-.03.064-.03.065-.029c.02-.01.044-.018.065-.027.023-.008.044-.018.066-.027l.069-.027.07-.026.072-.025c.024-.009.049-.017.073-.024l.076-.024c.024-.008.05-.015.077-.022l.079-.022.079-.02.08-.02.083-.02.084-.018.086-.017.088-.016.089-.015.091-.013c.032-.006.062-.009.093-.012a1.8 1.8 0 0 0 .095-.012l.096-.01c.034-.004.065-.007.098-.009l.1-.007c.034-.001.069-.003.102-.006.016 0 .033 0 .05-.002.015 0 .032 0 .048-.002.016 0 .032 0 .05-.002l.048-.001c.016 0 .032 0 .05-.002.015 0 .031 0 .047-.002H19.535c.014 0 .03 0 .043.002.015.002.03 0 .044.002l.044.001c.014 0 .03 0 .044.002.014.002.03 0 .044.002.014 0 .03 0 .044.002a.38.38 0 0 1 .043.003l.044.003.044.004a.38.38 0 0 1 .044.003c.014 0 .028.002.044.004l.044.003.043.003a.35.35 0 0 1 .043.004l.042.003.042.003c.014 0 .028.004.042.004l.042.003c.014 0 .028.004.042.005.014 0 .028.004.042.006.014 0 .028.003.042.005.014 0 .028.003.042.005.014 0 .028.003.042.005.014 0 .028.003.042.005l.042.005.04.005.041.005.04.005.04.005.041.006.04.005a.332.332 0 0 1 .04.006c.015.004.027.004.041.007-.003-.015-.005-.032-.009-.047l-.008-.048c-.004-.017-.008-.032-.01-.05-.001-.016-.006-.032-.01-.049l-.01-.049a.493.493 0 0 0-.013-.05l-.012-.049c-.003-.017-.009-.032-.012-.049l-.014-.05-.014-.048-.016-.05-.016-.05-.015-.048a.57.57 0 0 0-.018-.05c-.005-.017-.012-.032-.018-.049l-.019-.05-.02-.049-.02-.049a1.158 1.158 0 0 0-.021-.048c-.007-.015-.014-.032-.023-.047l-.023-.048a.634.634 0 0 0-.024-.047c-.01-.016-.016-.033-.025-.048l-.026-.046-.027-.046c-.008-.015-.017-.03-.028-.046l-.028-.046c-.01-.015-.019-.03-.03-.044l-.031-.044-.032-.044c-.01-.014-.02-.03-.033-.043l-.033-.042-.035-.041-.037-.04-.037-.042c-.012-.013-.026-.025-.038-.039l-.04-.039c-.015-.012-.027-.025-.041-.037a.94.94 0 0 0-.13-.107l-.046-.034a.78.78 0 0 0-.047-.033l-.047-.032-.05-.03a.481.481 0 0 0-.05-.03l-.053-.028c-.017-.009-.035-.02-.054-.028l-.054-.025c-.02-.009-.037-.017-.056-.024-.02-.007-.04-.015-.058-.024l-.06-.022-.06-.02c-.02-.007-.04-.014-.061-.019l-.063-.019-.065-.017a3.86 3.86 0 0 0-.067-.015c-.022-.005-.045-.008-.068-.014l-.07-.011a6.112 6.112 0 0 1-.07-.01c-.025-.004-.048-.008-.072-.01a1.079 1.079 0 0 0-.074-.006l-.075-.005a1.117 1.117 0 0 0-.077-.003c-.025 0-.048 0-.07-.002H18.262c-.022 0-.043 0-.066.002-.021 0-.044 0-.065.003-.021.003-.042.002-.063.003-.021 0-.042.004-.063.005-.021 0-.04.004-.062.005a.638.638 0 0 0-.06.007l-.059.007a.679.679 0 0 0-.058.009l-.058.008a3.06 3.06 0 0 0-.11.019l-.055.01a.593.593 0 0 0-.052.012c-.018.003-.035.008-.053.012a.443.443 0 0 0-.05.013l-.051.014-.05.014-.049.015-.047.015c-.016.005-.032.01-.046.016-.014.005-.03.01-.045.017-.016.005-.03.011-.044.017l-.044.017-.042.018-.042.019c-.014.007-.028.012-.04.019l-.04.02a.75.75 0 0 0-.04.02 12.172 12.172 0 0 0-.075.04l-.036.023c-.013.007-.025.016-.035.023-.013.006-.023.015-.035.022-.013.006-.023.015-.034.022l-.033.022-.033.024-.032.023-.031.024c-.011.009-.022.015-.03.024l-.03.024-.028.024a.349.349 0 0 1-.028.023.394.394 0 0 1-.028.026l-.027.025a6.426 6.426 0 0 0-.026.026c-.009.008-.018.017-.024.025l-.025.026-.025.025-.022.026-.023.025a4.74 4.74 0 0 0-.021.026l-.021.026-.021.025-.02.026-.019.025-.02.026c-.004.008-.011.017-.017.025l-.017.026c-.005.008-.01.017-.018.025l-.015.026-.023-.014-.023-.014-.023-.013-.023-.014-.023-.014-.022-.013-.023-.014-.023-.013-.023-.014-.022-.014-.023-.013-.023-.014-.023-.013-.023-.014-.022-.014-.023-.013-.023-.014-.023-.013-.023-.014-.022-.013-.023-.014-.023-.014-.023-.013-.023-.014-.022-.014-.023-.013-.023-.014-.023-.013-.022-.014-.023-.014-.023-.013-.023-.014-.023-.013-.023-.014-.022-.014-.023-.013-.023-.014-.023-.013-.023-.014-.022-.014-.023-.013-.023-.014-.023-.013-.022-.014-.023-.014-.023-.013-.023-.014-.023-.013-.022-.014-.023-.014-.023-.013-.023-.014-.023-.013-.022-.014-.023-.014-.023-.013-.023-.014-.023-.013-.022-.014-.023-.014-.023-.013-.023-.014-.022-.013-.023-.014c.005-.01.012-.019.019-.029.007-.01.012-.02.02-.03l.02-.031c.007-.01.014-.022.023-.032l.023-.034.024-.034a8.14 8.14 0 0 0 .027-.036l.026-.036c.009-.012.02-.024.028-.037l.03-.038c.01-.012.02-.025.032-.037l.031-.04.033-.038.035-.04a13.552 13.552 0 0 0 .076-.081l.038-.04.04-.042.043-.04c.014-.014.028-.028.044-.041l.045-.041.046-.04.047-.042.05-.04a1.26 1.26 0 0 1 .05-.041l.053-.041a1.422 1.422 0 0 1 .11-.082c.02-.013.037-.027.056-.04l.058-.041c.02-.014.04-.028.06-.04l.061-.038.063-.04a.789.789 0 0 1 .065-.037l.067-.037.068-.038.07-.036c.025-.011.048-.023.072-.035l.074-.034c.024-.012.049-.022.075-.034.025-.012.051-.022.077-.033l.08-.032a3.89 3.89 0 0 1 .162-.06l.084-.028c.029-.009.056-.019.086-.027l.088-.026.09-.025.09-.024c.03-.007.062-.016.094-.022l.094-.02c.032-.008.065-.014.097-.02l.098-.017.1-.015c.033-.005.068-.01.102-.013a385.852 385.852 0 0 0 .317-.03l.11-.008.113-.005.114-.003H18.532l.12.003c.037 0 .076.004.113.005.037.002.073.005.11.009l.11.01c.038.003.073.008.11.012l.107.015c.034.005.07.01.105.017l.105.019c.035.007.068.013.103.022.035.007.069.015.102.024l.1.025c.033.009.067.019.1.03l.098.03.097.032.094.036.095.037.093.04c.03.013.061.026.091.042.03.013.06.029.09.044.03.015.059.03.087.046.03.015.058.032.086.047.028.016.058.033.086.052l.084.052c.028.017.054.036.082.055l.081.056.079.058a.87.87 0 0 1 .077.06l.076.064.073.064.074.066.072.069.07.07.068.07c.023.024.044.05.067.075.02.026.044.052.065.077l.063.078.061.08c.021.027.04.054.06.082l.058.083.056.085c.02.029.037.058.054.087l.053.088c.017.03.035.06.05.09.018.03.034.062.05.092l.047.094.046.095c.014.032.03.064.043.097l.043.098.04.1c.012.035.026.069.039.103l.036.103c.013.036.023.07.035.106.01.036.023.071.032.107l.03.109.028.11.026.113c.009.037.018.074.025.113l.022.116.021.117c.008.04.013.079.02.12l.016.118.014.121c.005.04.008.082.012.122l.01.125.01.125a3.695 3.695 0 0 1 .243.1c.04.018.079.037.117.053.039.02.077.036.116.055l.114.056c.037.019.075.04.112.058.037.02.074.039.11.06l.108.06.105.063.103.065.102.066.1.068c.033.024.065.046.096.07l.095.072c.032.023.061.049.093.073l.091.074c.03.026.06.051.088.077.03.025.058.05.086.078l.084.08c.028.027.054.054.08.082l.08.081.077.084c.024.029.05.056.073.085a3.052 3.052 0 0 1 .142.175l.069.088.064.09.064.092.061.093c.02.031.038.064.058.094.02.03.037.063.056.095.018.033.037.065.053.097.017.032.035.065.05.097l.05.099c.015.032.031.066.045.1l.044.1.042.102c.014.034.026.068.039.104l.036.104c.013.034.023.07.034.105.01.036.02.072.031.106a9.9 9.9 0 0 1 .054.216c.01.035.016.073.025.108.009.036.014.073.021.11.007.038.012.074.02.111l.015.113c.006.037.009.074.014.112.006.037.007.075.01.114l.01.114c.001.037.005.076.005.115 0 .04.003.077.003.116v.116l-.001.117c-.002.039-.002.078-.006.117-.001.04-.003.078-.007.12-.003.038-.005.08-.01.118-.006.04-.007.08-.012.12l-.016.12-.018.12-.02.121-.024.123-.026.122c-.009.041-.02.082-.028.123-.007.029-.014.06-.023.088l-.024.088-.027.089c-.008.029-.019.06-.028.088l-.03.089-.031.088-.033.087a32.124 32.124 0 0 1-.076.173 34.422 34.422 0 0 1-.126.259l-.044.085-.045.085-.048.083-.049.083-.05.084c-.018.027-.036.054-.053.083l-.055.082a2.34 2.34 0 0 1-.114.161 2.43 2.43 0 0 1-.06.08l-.059.08c-.02.027-.04.053-.061.078l-.063.078-.065.077-.067.076c-.023.026-.044.051-.067.075-.022.026-.045.05-.068.075a2.673 2.673 0 0 1-.142.148l-.072.073c-.024.025-.049.048-.073.071-.025.024-.05.048-.076.07-.024.024-.05.046-.075.07l-.077.068-.08.068-.078.066a2.54 2.54 0 0 1-.08.065l-.083.064a2.65 2.65 0 0 1-.083.063l-.084.063c-.028.022-.056.041-.084.061-.028.02-.056.041-.086.06-.028.02-.058.039-.086.06-.03.018-.058.039-.087.057l-.088.056a1.53 1.53 0 0 1-.09.055c-.03.017-.06.035-.089.054a1.62 1.62 0 0 1-.091.053 4.142 4.142 0 0 0-.091.05 2.475 2.475 0 0 1-.186.097c-.032.016-.063.033-.095.048l-.095.046c-.031.016-.063.03-.094.044a1.622 1.622 0 0 1-.097.043c-.031.014-.064.027-.096.04a2.317 2.317 0 0 1-.195.076c-.033.013-.065.027-.098.039a6.265 6.265 0 0 0-.098.035c-.032.012-.067.022-.1.034l-.1.033c-.014.005-.03.008-.046.013l-.045.014c-.016.005-.03.008-.046.014l-.045.013-.046.014-.047.013-.048.014-.047.014-.047.012-.048.011c-.015.004-.031.009-.049.012l-.049.012-.049.012-.049.012-.049.012-.05.012a.549.549 0 0 0-.052.012l-.05.012-.051.01-.051.01-.051.01-.053.01-.052.01-.053.01-.053.011-.052.01-.053.01c-.017.004-.035.007-.054.009a.519.519 0 0 1-.054.008c-.018.004-.037.006-.055.009l-.054.008c-.018.004-.037.006-.055.009l-.054.008c-.017.004-.037.006-.054.009l-.056.008-.056.007-.056.007-.057.007-.056.007c-.019.001-.037.005-.056.006l-.056.007a.563.563 0 0 0-.056.007l-.058.005-.058.005-.058.005-.058.005c-.019 0-.038.004-.057.006-.02 0-.039.003-.058.005-.02 0-.039.003-.058.005-.02 0-.039.003-.058.003-.02 0-.039.003-.058.003-.02 0-.038.002-.06.004l-.06.003c-.018 0-.038.002-.059.004l-.06.003-.059.002c-.02 0-.04 0-.06.002l-.06.001h-.357L18.06 28Zm.864-9.734h-.501c-.018 0-.035 0-.05.002-.018 0-.036 0-.052.002l-.05.001c-.018 0-.036.002-.053.004-.018 0-.035.001-.053.003l-.052.003a.546.546 0 0 0-.053.004c-.017 0-.035.003-.053.005l-.052.005-.053.005-.05.005a.457.457 0 0 0-.052.007c-.017.002-.035.003-.05.007l-.051.007c-.018.001-.034.005-.051.006l-.05.009-.052.008c-.017.004-.033.007-.05.009l-.051.01-.05.01-.049.01c-.015.004-.033.007-.049.012-.015.006-.033.009-.049.012l-.049.014c-.016.005-.031.008-.047.014l-.048.013-.047.015-.047.016c-.016.005-.032.01-.046.017a.361.361 0 0 1-.045.017l-.046.017c-.016.005-.03.012-.044.018a.498.498 0 0 1-.044.02c-.014.004-.028.013-.044.02l-.042.02-.042.022-.04.022a1.217 1.217 0 0 0-.04.024l-.04.024-.04.025-.038.027c-.012.009-.024.02-.037.028a.522.522 0 0 0-.036.029l-.035.029-.036.03-.033.03c-.01.01-.02.023-.032.033l-.031.034c-.01.012-.021.022-.03.034l-.03.036a.307.307 0 0 0-.028.037c-.008.012-.017.026-.026.037l-.026.04-.025.04-.01.02-.01.018-.011.018a.184.184 0 0 1-.01.02c-.004.004-.008.013-.011.018a.106.106 0 0 0-.01.02c0 .007-.005.014-.008.02l-.009.021-.008.02-.01.021-.006.02c-.002.007-.006.014-.007.02-.002.008-.006.014-.007.021-.002.007-.006.014-.007.02l-.007.021c-.004.007-.004.014-.006.02l-.005.02-.005.021c0 .007-.004.014-.005.02l-.006.023c0 .006-.003.013-.003.022 0 .007-.004.013-.004.022l-.003.022c0 .007-.002.014-.004.022l-.003.022c0 .007 0 .015-.002.022 0 .007 0 .016-.002.022l-.001.023V19.994l.001.022c0 .006 0 .015.002.022 0 .006 0 .015.002.022.002.007.002.015.003.022a.1.1 0 0 0 .004.022l.003.022c0 .007.002.015.004.022l.003.022c0 .007.004.016.006.022 0 .007.003.016.005.023 0 .006.003.015.005.022l.005.022a.433.433 0 0 1 .006.022.105.105 0 0 0 .007.022c.001.007.005.014.007.022.001.007.005.014.007.022.001.009.005.014.007.022l.007.022a.106.106 0 0 0 .008.02l.01.021c.003.007.004.014.008.02l.009.021.009.02.01.02.01.021a55546059715.78 55546059715.78 0 0 0 .034.061c.007.014.016.028.024.041a.717.717 0 0 0 .055.078c.009.014.02.026.03.038l.031.037c.01.012.021.024.034.036a.604.604 0 0 1 .033.036l.035.034.037.034a.353.353 0 0 0 .038.032l.04.032c.015.01.029.02.04.033l.043.03.044.03c.014.011.03.02.045.03l.046.029c.016.008.032.018.047.027l.05.025.049.026a.456.456 0 0 0 .05.024l.051.023a.676.676 0 0 0 .053.023c.017.006.035.015.052.022l.055.02.054.02c.018.007.037.012.056.02l.056.018.056.017.058.015.058.015.058.014.06.014.06.012.059.01.06.01.06.009.062.008a.75.75 0 0 0 .062.007l.061.005c.021 0 .04.003.061.005.021 0 .042.002.062.003.019.002.042 0 .061.002.02.002.042 0 .061 0h.123c.02 0 .042 0 .062-.002.019-.001.042-.001.06-.003.022 0 .041-.003.062-.005l.062-.005.061-.007.061-.008.062-.01c.02-.004.04-.008.06-.01.019-.004.04-.01.059-.013a.752.752 0 0 0 .06-.013c.019-.006.038-.009.06-.014a348041545240.437 348041545240.437 0 0 0 .115-.032c.02-.006.038-.012.058-.02.02-.006.038-.011.056-.018l.056-.02a.766.766 0 0 0 .11-.046l.043-.019a.885.885 0 0 0 .04-.02l.04-.02a.474.474 0 0 0 .04-.023c.015-.007.027-.015.04-.022.015-.007.027-.015.04-.024a.472.472 0 0 1 .038-.023l.039-.026.036-.025.037-.028c.013-.008.025-.018.037-.028l.037-.03a.608.608 0 0 0 .035-.03l.035-.03.035-.033c.012-.01.023-.022.033-.032l.034-.034c.01-.012.023-.022.033-.034l.032-.036.031-.036a.724.724 0 0 0 .032-.037c.01-.012.02-.026.031-.037a.339.339 0 0 0 .03-.04l.03-.039.03-.04a.55.55 0 0 0 .028-.041l.028-.041.028-.043.026-.042.027-.044c.008-.016.017-.03.026-.045l.024-.045c.007-.016.016-.031.025-.046l.024-.048c.01-.015.016-.032.025-.047l.023-.05c.007-.017.016-.032.023-.05a.436.436 0 0 1 .022-.048l.021-.052.021-.05.021-.053c.008-.019.015-.036.02-.053l.019-.054c.007-.019.012-.036.02-.055l.017-.054.017-.056a.67.67 0 0 1 .018-.056c.007-.019.01-.038.016-.058l.015-.058.016-.058a.582.582 0 0 0 .014-.06c.006-.02.009-.038.014-.059.006-.02.01-.04.014-.06.006-.018.01-.04.013-.06l.012-.062.012-.063.01-.063.011-.062c.004-.023.007-.043.009-.065l.009-.065c.003-.022.005-.044.009-.064l.007-.067.006-.066.008-.066-.029-.005-.028-.005-.028-.006-.028-.005-.028-.005-.028-.005c-.009 0-.02-.003-.028-.005a.949.949 0 0 0-.03-.005l-.03-.005c-.01 0-.019-.003-.03-.005l-.03-.005-.029-.005c-.01 0-.02-.004-.03-.005-.01 0-.019-.004-.03-.006-.01 0-.019-.003-.03-.005-.01 0-.019-.003-.03-.003-.01 0-.018-.003-.029-.003-.01 0-.02-.004-.03-.004-.01 0-.019-.003-.03-.003-.01 0-.019-.004-.03-.004a.16.16 0 0 1-.03-.003.16.16 0 0 1-.029-.004.16.16 0 0 1-.03-.003.16.16 0 0 1-.03-.003c-.01 0-.02-.002-.031-.004a.198.198 0 0 1-.032-.003c-.01 0-.02-.002-.031-.004l-.032-.003a.2.2 0 0 1-.031-.003c-.01 0-.021-.002-.032-.004-.01 0-.021-.001-.031-.003-.011 0-.021-.002-.032-.003-.01 0-.021-.002-.032-.004a.2.2 0 0 1-.031-.003.198.198 0 0 1-.032-.004l-.031-.001c-.01 0-.021 0-.032-.002-.01-.002-.02 0-.031-.002-.01 0-.021 0-.032-.002l-.032-.001c-.01 0-.02 0-.031-.002-.01 0-.021 0-.033-.002l-.034-.001c-.01 0-.02 0-.033-.002-.01 0-.021 0-.033-.002H18.917l.007-.01Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "threadIcon_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(9 8)",
    d: "M0 0h18v20H0z"
  })))));
};
/* harmony default export */ var threadIcon = (SvgThreadIcon);
;// CONCATENATED MODULE: ./src/shared/icons/youtubeIcon.svg
var youtubeIcon_circle, youtubeIcon_path;
function youtubeIcon_extends() { return youtubeIcon_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, youtubeIcon_extends.apply(null, arguments); }

var SvgYoutubeIcon = function SvgYoutubeIcon(props) {
  return /*#__PURE__*/react.createElement("svg", youtubeIcon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), youtubeIcon_circle || (youtubeIcon_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E62117"
  })), youtubeIcon_path || (youtubeIcon_path = /*#__PURE__*/react.createElement("path", {
    d: "M27.582 13.186a2.505 2.505 0 0 0-1.768-1.768C24.254 11 18 11 18 11s-6.254 0-7.814.418c-.86.23-1.538.908-1.768 1.768C8 14.746 8 18 8 18s0 3.254.418 4.814c.23.86.908 1.538 1.768 1.768C11.746 25 18 25 18 25s6.254 0 7.814-.418a2.505 2.505 0 0 0 1.768-1.768C28 21.254 28 18 28 18s0-3.254-.418-4.814ZM16 21v-6l5.196 3L16 21Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var youtubeIcon = (SvgYoutubeIcon);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
;// CONCATENATED MODULE: ./src/widgets/magazine-author-detail/ui/MagazineAuthorInfo.tsx







var MagazineAuthorInfo = function(param) {
    var magazineAuthor = param.magazineAuthor, openSocialMediaLink = param.openSocialMediaLink, moveToAuthorHospital = param.moveToAuthorHospital;
    if (!magazineAuthor) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,style.cn)([
            "flex flex-col gap-[15px] p-[32px_24px]",
            "desktop:gap-[16px]"
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,style.cn)("flex flex-col justify-between gap-[15px]", "desktop:flex-row desktop:items-center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,style.cn)([
                            "flex flex-col gap-[24px]",
                            "desktop:flex-row desktop:items-center"
                        ]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "profile",
                                className: "h-[80px] w-[80px] rounded-full border-[1px] border-gray-50 border-solid bg-white",
                                src: magazineAuthor.profileImage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "typography-ui-22b mb-[4px] text-gray-700",
                                        children: magazineAuthor.getDisplayDoctorName()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "typography-ui-15r whitespace-pre-line text-gray-700",
                                        children: magazineAuthor.getProfileDescription()
                                    })
                                ]
                            })
                        ]
                    }),
                    magazineAuthor.isMagazineByDoctor() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            onClick: moveToAuthorHospital,
                            children: "병원 정보 보기"
                        })
                    })
                ]
            }),
            magazineAuthor.hasCareer() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-[4px] rounded-[8px] bg-gray-20 p-[20px]",
                children: magazineAuthor.getDisplayCareer().map(function(career) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "typography-ui-13r text-gray-400",
                        children: career.content
                    }, career.id);
                })
            }),
            magazineAuthor.isMagazineByDoctornow() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,style.cn)([
                    "flex gap-[12px] *:min-h-[37px] *:min-w-fit *:cursor-pointer",
                    "desktop:justify-end"
                ]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(instagramIcon, {
                        onClick: function() {
                            return openSocialMediaLink("instagram");
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(youtubeIcon, {
                        onClick: function() {
                            return openSocialMediaLink("youtube");
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(threadIcon, {
                        onClick: function() {
                            return openSocialMediaLink("thread");
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(naverBlogIcon, {
                        onClick: function() {
                            return openSocialMediaLink("naverBlog");
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_MagazineAuthorInfo = (MagazineAuthorInfo);

// EXTERNAL MODULE: ./src/components/common/PaginationComponent.tsx + 3 modules
var PaginationComponent = __webpack_require__(40906);
// EXTERNAL MODULE: ./src/components/common/WithHyperLinkComponent.tsx
var WithHyperLinkComponent = __webpack_require__(6329);
// EXTERNAL MODULE: ./src/components/common/communication/magazine/ListMagazineLine.tsx + 2 modules
var ListMagazineLine = __webpack_require__(79476);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/widgets/magazine-author-detail/ui/MagazineListByAuthorEmpty.tsx



var MagazineListByAuthorEmpty = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex h-[480px] items-center justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center gap-[15px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                    name: "upcoming",
                    size: 48,
                    color: theme/* default.color.gray100 */.Z.color.gray100,
                    filled: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "typography-ui-20sb text-gray-600",
                    children: "작성된 콘텐츠가 없어요"
                })
            ]
        })
    });
};
/* harmony default export */ var ui_MagazineListByAuthorEmpty = (MagazineListByAuthorEmpty);

;// CONCATENATED MODULE: ./src/widgets/magazine-author-detail/ui/MagazineListByAuthor.tsx






var MagazineListByAuthor = function(param) {
    var magazineByAuthorPublicId = param.magazineByAuthorPublicId, paginationBaseUrl = param.paginationBaseUrl, currentPage = param.currentPage, queries = param.queries;
    if (!magazineByAuthorPublicId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-[80px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "typography-ui-22sb p-[32px_24px_24px] pt-[32px] text-gray-700",
                children: "최신 콘텐츠"
            }),
            magazineByAuthorPublicId.magazines.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MagazineListByAuthorEmpty, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: magazineByAuthorPublicId.magazines.map(function(magazine, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WithHyperLinkComponent/* default */.Z, {
                                href: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid),
                                target: "_self",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine/* default */.Z, {
                                    magazine: {
                                        magazinePid: magazine.magazinePid,
                                        title: magazine.title,
                                        mobileTitle: magazine.mobileTitle,
                                        image: magazine.titleImageUrl,
                                        date: magazine.getFormattedCreatedAt(),
                                        description: magazine.description,
                                        mobileDescription: magazine.mobileDescription
                                    }
                                }, index)
                            }, magazine.magazinePid);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationComponent/* default */.Z, {
                        baseUrl: paginationBaseUrl,
                        queries: queries,
                        currentPage: currentPage,
                        perPage: 5,
                        totalPage: magazineByAuthorPublicId.totalPageCount
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_MagazineListByAuthor = (MagazineListByAuthor);

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(98240);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(22710);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/magazine/magazine.gql.impl.tsx
var magazine_gql_impl = __webpack_require__(44355);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(95210);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/views/magazine-author-detail/model/magazine.ts




var EDoctorCareer;
(function(EDoctorCareer) {
    EDoctorCareer["Current"] = "CURRENT";
    EDoctorCareer["Past"] = "PAST";
    EDoctorCareer["Graduation"] = "GRADUATION";
    EDoctorCareer["Completion"] = "COMPLETION";
    EDoctorCareer["Unknown"] = "UNKNOWN";
})(EDoctorCareer || (EDoctorCareer = {}));
var EAffiliationType;
(function(EAffiliationType) {
    EAffiliationType["Doctornow"] = "DOCTORNOW";
    EAffiliationType["Hospital"] = "HOSPITAL";
    EAffiliationType["Pharmacy"] = "PHARMACY";
    EAffiliationType["Unknown"] = "UNKNOWN";
})(EAffiliationType || (EAffiliationType = {}));
var MagazineAuthorModel = /*#__PURE__*/ function() {
    "use strict";
    function MagazineAuthorModel(_magazineAuthor) {
        (0,_class_call_check/* default */.Z)(this, MagazineAuthorModel);
        this.affiliation = _magazineAuthor.affiliation;
        this.career = _magazineAuthor.career;
        this.name = _magazineAuthor.name;
        this.profileDescription = _magazineAuthor.profileDescription;
        this.profileImage = _magazineAuthor.profileImage;
        this.publicId = _magazineAuthor.publicId;
    }
    var _proto = MagazineAuthorModel.prototype;
    _proto.isMagazineByDoctor = function isMagazineByDoctor() {
        var ref;
        return ((ref = this.affiliation) === null || ref === void 0 ? void 0 : ref.affiliationType) === EAffiliationType.Hospital;
    };
    _proto.isMagazineByDoctornow = function isMagazineByDoctornow() {
        var ref;
        return ((ref = this.affiliation) === null || ref === void 0 ? void 0 : ref.affiliationType) === EAffiliationType.Doctornow;
    };
    _proto.getDisplayDoctorName = function getDisplayDoctorName() {
        if (this.isMagazineByDoctor()) {
            return "".concat(this.name, " 의사");
        }
        return this.name;
    };
    _proto.getProfileDescription = function getProfileDescription() {
        return this.profileDescription;
    };
    _proto.getDisplayCareerType = function getDisplayCareerType(careerType) {
        switch(careerType){
            case EDoctorCareer.Current:
                return "현";
            case EDoctorCareer.Past:
                return "전";
            case EDoctorCareer.Graduation:
                return "졸업";
            case EDoctorCareer.Completion:
                return "수료";
            case EDoctorCareer.Unknown:
                return "";
        }
    };
    _proto.hasCareer = function hasCareer() {
        return this.career.length > 0;
    };
    _proto.getDisplayCareer = function getDisplayCareer() {
        var _this = this;
        return this.career.map(function(career) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, career), {
                content: "".concat(_this.getDisplayCareerType(career.careerType), ") ").concat(career.content)
            });
        });
    };
    return MagazineAuthorModel;
}();
var MagazineByAuthorPublicIdModel = /*#__PURE__*/ function() {
    "use strict";
    function MagazineByAuthorPublicIdModel(_magazineByAuthorPublicId) {
        (0,_class_call_check/* default */.Z)(this, MagazineByAuthorPublicIdModel);
        this.createdAt = _magazineByAuthorPublicId.createdAt;
        this.description = _magazineByAuthorPublicId.description;
        this.titleImageUrl = _magazineByAuthorPublicId.titleImageUrl;
        this.magazinePid = _magazineByAuthorPublicId.magazinePid;
        this.mobileDescription = _magazineByAuthorPublicId.mobileDescription;
        this.title = _magazineByAuthorPublicId.title;
        this.mobileTitle = _magazineByAuthorPublicId.mobileTitle;
    }
    var _proto = MagazineByAuthorPublicIdModel.prototype;
    _proto.getFormattedCreatedAt = function getFormattedCreatedAt() {
        return dayjs_min_default()(this.createdAt).format("YYYY.MM.DD");
    };
    return MagazineByAuthorPublicIdModel;
}();

;// CONCATENATED MODULE: ./src/views/magazine-author-detail/hooks/useGetMagazineAuthor.ts





var parseAffiliationType = function(affiliationType) {
    switch(affiliationType){
        case "DOCTORNOW":
            return EAffiliationType.Doctornow;
        case "HOSPITAL":
            return EAffiliationType.Hospital;
        case "PHARMACY":
            return EAffiliationType.Pharmacy;
        default:
            return EAffiliationType.Unknown;
    }
};
var parseCareerType = function(careerType) {
    switch(careerType){
        case gql_schema/* DoctorCareerType.Current */.TMd.Current:
            return EDoctorCareer.Current;
        case gql_schema/* DoctorCareerType.Past */.TMd.Past:
            return EDoctorCareer.Past;
        case gql_schema/* DoctorCareerType.Graduation */.TMd.Graduation:
            return EDoctorCareer.Graduation;
        case gql_schema/* DoctorCareerType.Completion */.TMd.Completion:
            return EDoctorCareer.Completion;
        default:
            return EDoctorCareer.Unknown;
    }
};
var parseGetMagazineAuthor = function(data) {
    if (!data.magazineAuthor) {
        return null;
    }
    var _profileDescription, _profileImage;
    return new MagazineAuthorModel({
        affiliation: data.magazineAuthor.affiliation ? {
            affiliationType: parseAffiliationType(data.magazineAuthor.affiliation.affiliationType),
            affiliationPid: data.magazineAuthor.affiliation.affiliationPid,
            name: data.magazineAuthor.affiliation.name
        } : null,
        career: data.magazineAuthor.career.map(function(career) {
            return {
                careerType: parseCareerType(career.careerType),
                content: career.content,
                id: career.id,
                isRepresentative: career.isRepresentative
            };
        }),
        name: data.magazineAuthor.name,
        profileDescription: (_profileDescription = data.magazineAuthor.profileDescription) !== null && _profileDescription !== void 0 ? _profileDescription : "",
        profileImage: (_profileImage = data.magazineAuthor.profileImage) !== null && _profileImage !== void 0 ? _profileImage : "",
        publicId: data.magazineAuthor.publicId
    });
};
var useGetMagazineAuthor = function(param) {
    var authorPublicId = param.authorPublicId;
    var ref = (0,magazine_gql_impl/* useGetMagazineAuthorQuery */.YL)({
        authorPublicId: authorPublicId
    }, {
        select: parseGetMagazineAuthor
    }), magazineAuthor = ref.data;
    return {
        magazineAuthor: magazineAuthor
    };
};
/* harmony default export */ var hooks_useGetMagazineAuthor = (useGetMagazineAuthor);
useGetMagazineAuthor.getKey = function(authorPublicId) {
    return magazine_gql_impl/* useGetMagazineAuthorQuery.getKey */.YL.getKey({
        authorPublicId: authorPublicId
    });
};
useGetMagazineAuthor.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, authorPublicId) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(magazine_gql_impl/* useGetMagazineAuthorQuery.getKey */.YL.getKey({
                            authorPublicId: authorPublicId
                        }), magazine_gql_impl/* useGetMagazineAuthorQuery.fetcher */.YL.fetcher({
                            authorPublicId: authorPublicId
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, authorPublicId) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/views/magazine-author-detail/hooks/useGetMagazineByAuthorPublicId.ts




var parseMagazineByAuthorPublicId = function(data) {
    return {
        totalCount: data.magazineByAuthorPublicId.totalCount,
        totalPageCount: data.magazineByAuthorPublicId.totalPageCount,
        magazines: data.magazineByAuthorPublicId.magazines.map(function(magazine) {
            return new MagazineByAuthorPublicIdModel({
                createdAt: magazine.createdAt,
                description: magazine.description,
                titleImageUrl: magazine.titleImageUrl,
                magazinePid: magazine.magazinePid,
                mobileDescription: magazine.mobileDescription,
                title: magazine.title,
                mobileTitle: magazine.mobileTitle
            });
        })
    };
};
var DEFAULT_PAGE_SIZE = 10;
var useGetMagazineByAuthorPublicId = function(param) {
    var authorPublicId = param.authorPublicId, page = param.page;
    var ref = (0,magazine_gql_impl/* useGetMagazineByAuthorPublicIdQuery */.uW)({
        authorPublicId: authorPublicId,
        pagingRequest: {
            page: page,
            limit: DEFAULT_PAGE_SIZE
        }
    }, {
        select: parseMagazineByAuthorPublicId
    }), magazineByAuthorPublicId = ref.data;
    return {
        magazineByAuthorPublicId: magazineByAuthorPublicId
    };
};
/* harmony default export */ var hooks_useGetMagazineByAuthorPublicId = (useGetMagazineByAuthorPublicId);
useGetMagazineByAuthorPublicId.getKey = function(variables) {
    return magazine_gql_impl/* useGetMagazineByAuthorPublicIdQuery.getKey */.uW.getKey(variables);
};
useGetMagazineByAuthorPublicId.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, variables) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(magazine_gql_impl/* useGetMagazineByAuthorPublicIdQuery.getKey */.uW.getKey(variables), magazine_gql_impl/* useGetMagazineByAuthorPublicIdQuery.fetcher */.uW.fetcher(variables))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, variables) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/views/magazine-author-detail/hooks/useMagazineAuthorDetailViewModel.ts







var useMagazineAuthorDetailViewModel = function() {
    var router = (0,next_router.useRouter)();
    var _ref = router.isReady ? router.query : {
        id: "",
        page: "1"
    }, id = _ref.id, queries = (0,_object_without_properties/* default */.Z)(_ref, [
        "id"
    ]);
    var currentPage = Number(queries.page) || 1;
    var navigate = (0,useNavigate/* default */.Z)();
    var magazineAuthor = hooks_useGetMagazineAuthor({
        authorPublicId: id
    }).magazineAuthor;
    var magazineByAuthorPublicId = hooks_useGetMagazineByAuthorPublicId({
        authorPublicId: id,
        page: currentPage
    }).magazineByAuthorPublicId;
    var openOutLink = function(url) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER */.nn.OPEN_EXTERNAL_BROWSER, {
                url: url
            });
        } else {
            window.open(url, "_blank");
        }
    };
    var openSocialMediaLink = function(type) {
        switch(type){
            case "instagram":
                openOutLink("https://www.instagram.com/doctornow_official");
                break;
            case "youtube":
                openOutLink("https://www.youtube.com/@doctornow_official");
                break;
            case "thread":
                openOutLink("https://www.threads.com/@doctornow_official");
                break;
            case "naverBlog":
                openOutLink("https://blog.naver.com/doctornow_official");
                break;
        }
    };
    var moveToAuthorHospital = function() {
        if (!magazineAuthor) {
            return;
        }
        if (!magazineAuthor.affiliation) {
            return;
        }
        navigate.navigateToHospitalDetail({
            hospitalPid: magazineAuthor.affiliation.affiliationPid
        });
    };
    var paginationBaseUrl = "".concat(common/* ROUTES.AUTHOR.DETAIL.path */.Z6.AUTHOR.DETAIL.path, "/").concat(id);
    return {
        id: id,
        currentPage: currentPage,
        queries: queries,
        paginationBaseUrl: paginationBaseUrl,
        magazineAuthor: magazineAuthor,
        magazineByAuthorPublicId: magazineByAuthorPublicId,
        openSocialMediaLink: openSocialMediaLink,
        moveToAuthorHospital: moveToAuthorHospital
    };
};
/* harmony default export */ var hooks_useMagazineAuthorDetailViewModel = (useMagazineAuthorDetailViewModel);

;// CONCATENATED MODULE: ./src/views/magazine-author-detail/ui/MagazineAuthorDetailView.tsx










var MagazineAuthorDetailView = function(param) {
    var client = param.client;
    var ref, ref1;
    var viewModel = hooks_useMagazineAuthorDetailViewModel();
    var shouldShowBreadCrumbs = client.clientType === app/* ClientType.WEB */.B.WEB;
    if (!viewModel.magazineAuthor) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFoundTemplate/* default */.Z, {});
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    suppressHydrationWarning: true,
                    children: shouldShowBreadCrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                            visible: true,
                            name: (ref2 = (ref = viewModel.magazineAuthor) === null || ref === void 0 ? void 0 : ref.getDisplayDoctorName()) !== null && ref2 !== void 0 ? ref2 : "",
                            path: "".concat(common/* ROUTES.AUTHOR.DETAIL.path */.Z6.AUTHOR.DETAIL.path, "/").concat(viewModel.id),
                            type: "magazine-author",
                            urlParameter: viewModel.id
                        })
                    })
                }),
                client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                    useSafeArea: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyAppHeader/* default */.Z, {
                        title: (ref1 = viewModel.magazineAuthor) === null || ref1 === void 0 ? void 0 : ref1.getDisplayDoctorName()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MagazineAuthorInfo, {
                            magazineAuthor: viewModel.magazineAuthor,
                            openSocialMediaLink: viewModel.openSocialMediaLink,
                            moveToAuthorHospital: viewModel.moveToAuthorHospital
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[1px] w-full bg-gray-40"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MagazineListByAuthor, {
                            magazineByAuthorPublicId: viewModel.magazineByAuthorPublicId,
                            currentPage: viewModel.currentPage,
                            queries: viewModel.queries,
                            paginationBaseUrl: viewModel.paginationBaseUrl
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ui_MagazineAuthorDetailView = (MagazineAuthorDetailView);

// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
;// CONCATENATED MODULE: ./src/pages/author/[id]/index.tsx
// PageDescription: 매거진 에디터 상세 페이지



var MagazineAuthorDetailPage = function(param) {
    var client = param.client;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "건강 매거진 - 닥터나우",
                description: "건강에 대한 궁금증을 닥터나우만의 전문 콘텐츠로 해결해 보세요."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MagazineAuthorDetailView, {
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _id_ = (MagazineAuthorDetailPage);


/***/ }),

/***/ 76666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40489);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98388);


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ }),

/***/ 10929:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ cva; }
/* harmony export */ });
/* unused harmony export cx */
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40489);
/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ 
const falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const cx = clsx__WEBPACK_IMPORTED_MODULE_0__/* .clsx */ .W;
const cva = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants, defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) {
                return acc;
            }
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };



/***/ }),

/***/ 77482:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createLucideIcon; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/shared/src/utils.js
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const mergeClasses = (...classes) => classes.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/defaultAttributes.js
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/Icon.js
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */





const Icon = (0,react.forwardRef)(
  ({
    color = "currentColor",
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref) => {
    return (0,react.createElement)(
      "svg",
      {
        ref,
        ...defaultAttributes,
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: mergeClasses("lucide", className),
        ...rest
      },
      [
        ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    );
  }
);


//# sourceMappingURL=Icon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/createLucideIcon.js
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */





const createLucideIcon = (iconName, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ className, ...props }, ref) => (0,react.createElement)(Icon, {
      ref,
      iconNode,
      className: mergeClasses(`lucide-${toKebabCase(iconName)}`, className),
      ...props
    })
  );
  Component.displayName = `${iconName}`;
  return Component;
};


//# sourceMappingURL=createLucideIcon.js.map


/***/ }),

/***/ 60301:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Ellipsis; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77482);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
];
const Ellipsis = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Ellipsis", __iconNode);


//# sourceMappingURL=ellipsis.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,4329,6562,2367,9774,2888,179], function() { return __webpack_exec__(804); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);